import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Date: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  /** Fetch a single applicant match record by its legacy ID. */
  applicant?: Maybe<Applicant>;
  cultureHotspots?: Maybe<Array<Maybe<CultureHotspot>>>;
  culturePerception?: Maybe<CulturePerceptionResult>;
  divisions: Array<Division>;
  feedbackThemes?: Maybe<Array<FeedbackTheme>>;
  getComponoAssistReaction?: Maybe<ComponoAssistReaction>;
  group?: Maybe<Group>;
  groupMember?: Maybe<GroupMember>;
  groupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  hireReportProcess: HireReportProcess;
  hireReportResult?: Maybe<HireReportResult>;
  /** Return true if the listing's match scores are currently being recalculated. */
  isProcessingListingMatches: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<MessageTemplate>;
  messageTemplateGenerate?: Maybe<MessageTemplateGeneratedResult>;
  messageTemplates?: Maybe<Array<Maybe<MessageTemplate>>>;
  myCourses?: Maybe<Array<Course>>;
  myGroupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  myProfile?: Maybe<User>;
  organisationTags: Array<OrganisationTag>;
  /** Fetch a single talent pool candidate by ID. */
  organisationTalent?: Maybe<OrganisationTalent>;
  /** Search the organisation's talent pool. */
  organisationTalents?: Maybe<Array<OrganisationTalent>>;
  permissions?: Maybe<Permission>;
  personalityAssessment?: Maybe<PersonalityAssessment>;
  personalityResults?: Maybe<Array<Maybe<PersonalityAssessmentResult>>>;
  rehydrateQualifications?: Maybe<Array<Qualification>>;
  rehydrateSkills?: Maybe<Array<Skill>>;
  rehydrateWorkAreas?: Maybe<Array<WorkArea>>;
  sharePageLinks?: Maybe<Array<Maybe<SharePage>>>;
  ssoConfig?: Maybe<SsoConfig>;
  ssoConnection?: Maybe<SsoConnection>;
  ssoConnections: Array<SsoConnection>;
  /** Get a standalone CV by ID */
  standaloneCV?: Maybe<StandaloneCv>;
  systemTags: Array<SystemTag>;
  tagActivities: Array<TagActivity>;
  /** Get an upload request by ID */
  uploadRequest?: Maybe<UploadRequest>;
  userGroupMembers?: Maybe<Array<Maybe<GroupMember>>>;
};


export type QueryApplicantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCultureHotspotsArgs = {
  campaignSk?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCulturePerceptionArgs = {
  assessmentSk: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<CulturePerceptionFilterInput>>>;
};


export type QueryFeedbackThemesArgs = {
  campaignSk: Scalars['String']['input'];
};


export type QueryGetComponoAssistReactionArgs = {
  input: GetComponoAssistReactionInput;
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupMemberArgs = {
  input?: InputMaybe<GroupMemberInput>;
};


export type QueryGroupMembersArgs = {
  input?: InputMaybe<GroupMembersInput>;
};


export type QueryGroupsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHireReportProcessArgs = {
  params: ReportInput;
};


export type QueryHireReportResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsProcessingListingMatchesArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageTemplateGenerateArgs = {
  additionalInstruction?: InputMaybe<Scalars['String']['input']>;
  previousAnswer?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessageTemplatesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganisationTalentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganisationTalentsArgs = {
  input?: InputMaybe<OrganisationTalentSearchInput>;
};


export type QueryPersonalityResultsArgs = {
  filters?: InputMaybe<Array<InputMaybe<PersonalityResultsQueryInput>>>;
};


export type QueryRehydrateQualificationsArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryRehydrateSkillsArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryRehydrateWorkAreasArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QuerySsoConnectionArgs = {
  id: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QuerySsoConnectionsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryStandaloneCvArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagActivitiesArgs = {
  filter: TagActivityFilter;
};


export type QueryUploadRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserGroupMembersArgs = {
  input?: InputMaybe<UserGroupMemberInput>;
};

/** A candidate matched to a specific job listing. */
export type Applicant = {
  __typename?: 'Applicant';
  /** The ID of the candidate matched to this listing. */
  candidateId: Scalars['ID']['output'];
  /** Unique identifier for this applicant match record. */
  id: Scalars['ID']['output'];
  /** The ID of the listing this applicant is matched to. */
  listingId: Scalars['ID']['output'];
  /** Protected profile stub for the CV summary federation chain. Uses the legacy type name for backward compatibility with the candidates subgraph. */
  protectedProfile?: Maybe<ListingApplicantProtectedProfile>;
};

/**
 * Backward-compat stub for the candidate CV-summary entity.
 * Owned and resolved by the candidates subgraph.
 * @deprecated Use ApplicantProtectedProfile. Remove after frontend migration.
 */
export type ListingApplicantProtectedProfile = {
  __typename?: 'ListingApplicantProtectedProfile';
  candidateId: Scalars['ID']['output'];
  cvId?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryId?: Maybe<Scalars['ID']['output']>;
};

export type CultureHotspot = {
  __typename?: 'CultureHotspot';
  aggregateFilter?: Maybe<Scalars['String']['output']>;
  aggregation?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['JSON']['output']>;
  desired?: Maybe<Scalars['JSON']['output']>;
  hasParent?: Maybe<Scalars['Boolean']['output']>;
  pk?: Maybe<Scalars['String']['output']>;
  responseCount?: Maybe<Scalars['Int']['output']>;
  sk?: Maybe<Scalars['String']['output']>;
};

export type CulturePerceptionFilterInput = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CulturePerceptionResult = {
  __typename?: 'CulturePerceptionResult';
  completedUsersCount?: Maybe<Scalars['Int']['output']>;
  perceptionAverage?: Maybe<AssessmentPerception>;
  perceptionList?: Maybe<Array<Maybe<AssessmentPerception>>>;
  totalUsersCompleted?: Maybe<Scalars['Int']['output']>;
};

export type AssessmentPerception = {
  __typename?: 'AssessmentPerception';
  customerQuality?: Maybe<Scalars['Float']['output']>;
  financial?: Maybe<Scalars['Float']['output']>;
  jobEngagement?: Maybe<Scalars['Float']['output']>;
  jobSatisfaction?: Maybe<Scalars['Float']['output']>;
  learningGrowth?: Maybe<Scalars['Float']['output']>;
  operational?: Maybe<Scalars['Float']['output']>;
  overallClimate?: Maybe<Scalars['Float']['output']>;
  turnoverIntention?: Maybe<Scalars['Float']['output']>;
  workMotivation?: Maybe<Scalars['Float']['output']>;
};

export type Division = {
  __typename?: 'Division';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackTheme = {
  __typename?: 'FeedbackTheme';
  id: Scalars['ID']['output'];
  intents: Array<FeedbackSentimentIntent>;
  isNoise: Scalars['Boolean']['output'];
  originalFeedbackSks: Array<OriginalFeedbackReference>;
  processed: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FeedbackSentimentIntent = {
  __typename?: 'FeedbackSentimentIntent';
  id?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type OriginalFeedbackReference = {
  __typename?: 'OriginalFeedbackReference';
  index: Scalars['Int']['output'];
  sk: Scalars['String']['output'];
};

export type GetComponoAssistReactionInput = {
  keys: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type ComponoAssistReaction = {
  __typename?: 'ComponoAssistReaction';
  data?: Maybe<Scalars['JSON']['output']>;
  feedback: FeedbackType;
};

export enum FeedbackType {
  Disliked = 'disliked',
  Liked = 'liked',
  Neutral = 'neutral'
}

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberCount?: Maybe<Scalars['Int']['output']>;
  members?: Maybe<Array<Maybe<User>>>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type User = {
  __typename?: 'User';
  accesses?: Maybe<UserAccesses>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastSigninAt?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  userPool?: Maybe<Scalars['String']['output']>;
};

export type UserAccesses = {
  __typename?: 'UserAccesses';
  genericApps?: Maybe<Array<UserAccessGenericApp>>;
};

export type UserAccessGenericApp = {
  __typename?: 'UserAccessGenericApp';
  appCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
};

export type GroupMemberInput = {
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
};

export enum MemberType {
  Candidate = 'candidate',
  Employer = 'employer'
}

export type GroupMember = {
  __typename?: 'GroupMember';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  member?: Maybe<User>;
  memberId: Scalars['ID']['output'];
  memberType?: Maybe<MemberType>;
  organisationId: Scalars['ID']['output'];
  role?: Maybe<GroupRole>;
  roleDisplayName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum GroupRole {
  Facilitator = 'facilitator',
  Learner = 'learner',
  Manager = 'manager'
}

export type GroupMembersInput = {
  groupId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
  role?: InputMaybe<GroupRole>;
};

export type ReportInput = {
  endDate: Scalars['String']['input'];
  hiringTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
};

export type HireReportProcess = {
  __typename?: 'HireReportProcess';
  id: Scalars['ID']['output'];
};

export type HireReportResult = {
  __typename?: 'HireReportResult';
  export: HireReportExport;
  id: Scalars['ID']['output'];
  report: HireReportStats;
};

export type HireReportExport = {
  __typename?: 'HireReportExport';
  csvUrl: Scalars['String']['output'];
  noOfEntries: Scalars['Int']['output'];
};

export type HireReportStats = {
  __typename?: 'HireReportStats';
  aggregates: HireReport;
  applicationSources: HireReportApplicationSources;
};

export type HireReport = {
  __typename?: 'HireReport';
  avgTimeToFillInDays: Scalars['Float']['output'];
  avgTimeToHireInDays: Scalars['Float']['output'];
  jobsClosedInPeriod: Scalars['Int']['output'];
  jobsOpenAtEndDate: Scalars['Int']['output'];
  jobsOpenAtStartDate: Scalars['Int']['output'];
  jobsOpenedInPeriod: Scalars['Int']['output'];
  totalApplications: Scalars['Int']['output'];
  totalHires: Scalars['Int']['output'];
};

export type HireReportApplicationSources = {
  __typename?: 'HireReportApplicationSources';
  all: Array<HireReportApplicationSourceCount>;
  hired: Array<HireReportApplicationSourceCount>;
};

export type HireReportApplicationSourceCount = {
  __typename?: 'HireReportApplicationSourceCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['ID']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MessageTemplateGeneratedResult = {
  __typename?: 'MessageTemplateGeneratedResult';
  errors?: Maybe<Array<Maybe<MessageTemplateMutationError>>>;
  messageTemplateGenerated?: Maybe<MessageTemplateGenerated>;
};

export type MessageTemplateMutationError = {
  __typename?: 'MessageTemplateMutationError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateGenerated = {
  __typename?: 'MessageTemplateGenerated';
  content: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type Course = {
  __typename?: 'Course';
  authorName?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  enrolmentStatus?: Maybe<Scalars['String']['output']>;
  hasAssessments?: Maybe<Scalars['Boolean']['output']>;
  hasEvents?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrganisationTag = {
  __typename?: 'OrganisationTag';
  assignedCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tagCategory?: Maybe<Scalars['String']['output']>;
};

/** A candidate in the organisation's talent pool. */
export type OrganisationTalent = {
  __typename?: 'OrganisationTalent';
  /** History of applications this candidate has submitted within the organisation. */
  applicationHistory?: Maybe<Array<OrganisationTalentApplication>>;
  /** IDs of file attachments on this candidate's profile. */
  attachmentIds?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<OrganisationTalentContact>;
  /** The candidate's current contact location. */
  contactLocation?: Maybe<OrganisationTalentLocation>;
  /** ID of the candidate's CV document. */
  cvId?: Maybe<Scalars['ID']['output']>;
  documents?: Maybe<Array<OrganisationTalentDocument>>;
  /** Education history entries for this candidate. */
  education?: Maybe<Array<OrganisationTalentEducation>>;
  email?: Maybe<Scalars['String']['output']>;
  /** The candidate's preferred employment types. */
  employmentOptions: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this talent pool entry (the candidate ID). */
  id: Scalars['ID']['output'];
  /** Work history entries for this candidate. */
  jobs?: Maybe<Array<OrganisationTalentJob>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSigninAt?: Maybe<Scalars['String']['output']>;
  /** Primary phone number of the candidate. */
  phone1?: Maybe<Scalars['String']['output']>;
  /** Data prepopulation status for this candidate. */
  prePopulate?: Maybe<PrePopulate>;
  /** Professional links (e.g. LinkedIn, portfolio) provided by the candidate. */
  professionalLinks?: Maybe<Array<OrganisationTalentProfessionalLink>>;
  /** The relevance score assigned by the talent pool search. */
  rankingScore?: Maybe<Scalars['Float']['output']>;
  /** Locations the candidate is willing to relocate to. */
  willRelocateTo?: Maybe<Array<OrganisationTalentLocation>>;
  /** The candidate's work personality type, derived from assessment responses. */
  workPersonalityType?: Maybe<Scalars['String']['output']>;
};

/** A record of a candidate's prior application within this organisation, as seen from the talent pool. */
export type OrganisationTalentApplication = {
  __typename?: 'OrganisationTalentApplication';
  applicantId: Scalars['ID']['output'];
  /** The date and time the candidate submitted this application. */
  appliedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the current user's team has permission to view this application. */
  canView?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for this application record. */
  id: Scalars['ID']['output'];
  /** The title of the job listing. */
  jobTitle: Scalars['String']['output'];
  /** The listing id this application was submitted for. */
  listingId: Scalars['ID']['output'];
  /** The ID of the pipeline stage this application is currently in. */
  stageId?: Maybe<Scalars['ID']['output']>;
  /** The name of the pipeline stage this application is currently in. */
  stageName?: Maybe<Scalars['String']['output']>;
  /** The hiring team associated with this listing. */
  team?: Maybe<Team>;
};

/** A hiring team. Owned by the organisations service; referenced here as a stub for federation delegation. */
export type Team = {
  __typename?: 'Team';
  /** Unique identifier for this team. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
};

export type OrganisationTalentContact = {
  __typename?: 'OrganisationTalentContact';
  phone1?: Maybe<Scalars['String']['output']>;
};

/** A geographic location associated with a candidate. */
export type OrganisationTalentLocation = {
  __typename?: 'OrganisationTalentLocation';
  /** City or suburb. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name or code. */
  country?: Maybe<Scalars['String']['output']>;
  /** Whether the candidate requires a visa to work at this location. */
  requiresVisa?: Maybe<Scalars['Boolean']['output']>;
  /** State or region. */
  state?: Maybe<Scalars['String']['output']>;
};

export type OrganisationTalentDocument = {
  __typename?: 'OrganisationTalentDocument';
  availableFormats?: Maybe<Array<OrganisationTalentDocumentFormat>>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: OrganisationTalentDocumentType;
};

export type OrganisationTalentDocumentFormat = {
  __typename?: 'OrganisationTalentDocumentFormat';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export enum OrganisationTalentDocumentType {
  CoverLetter = 'coverLetter',
  Cv = 'cv',
  Other = 'other'
}

/** An education history entry for an organisation talent candidate. */
export type OrganisationTalentEducation = {
  __typename?: 'OrganisationTalentEducation';
  /** True if the qualification was completed. */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** End date of the education. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** ID of the educational institution. */
  institutionId?: Maybe<Scalars['ID']['output']>;
  /** Name of the educational institution. */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** The qualification obtained. */
  qualification?: Maybe<Qualification>;
  /** Start date of the education. */
  startDate?: Maybe<Scalars['String']['output']>;
};

/** A qualification. Owned by the options service; matchmaker extends with subCategoryIds. */
export type Qualification = {
  __typename?: 'Qualification';
  /** Unique identifier for this qualification. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** IDs of the sub-categories associated with this qualification. */
  subCategoryIds: Array<Scalars['String']['output']>;
  typeId: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

/** A work history entry for an organisation talent candidate. */
export type OrganisationTalentJob = {
  __typename?: 'OrganisationTalentJob';
  /** Name of the employer. */
  company?: Maybe<Scalars['String']['output']>;
  /** True if this is the candidate's current job. */
  currentJob?: Maybe<Scalars['Boolean']['output']>;
  /** End date of the role. Null if still current. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Skills used in this role. */
  skills: Array<Skill>;
  /** Start date of the role. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Job title held. */
  title?: Maybe<Scalars['String']['output']>;
  /** Total years in this role, computed from start/end dates. */
  years?: Maybe<Scalars['Float']['output']>;
};

/** A skill. Owned by the options service; referenced here as a stub for federation delegation. */
export type Skill = {
  __typename?: 'Skill';
  /** Unique identifier for this skill. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Candidate data-prepopulation consent and status flags. */
export type PrePopulate = {
  __typename?: 'PrePopulate';
  /** Whether prepopulation is allowed for this candidate. */
  allowed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the candidate profile has been prepopulated. */
  isPrePopulated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the candidate has confirmed the prepopulated data. */
  userConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

/** A professional external link on a candidate's profile (e.g. LinkedIn, portfolio). */
export type OrganisationTalentProfessionalLink = {
  __typename?: 'OrganisationTalentProfessionalLink';
  /** Display label for the link. */
  label: Scalars['String']['output'];
  /** The URL of the link. */
  url: Scalars['String']['output'];
};

/** Filter criteria for the talent pool search. */
export type OrganisationTalentSearchInput = {
  /** When true, include candidates willing to relocate to the specified locations. */
  acceptRelocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, also match qualifications related via sub-categories. */
  includeRelatedQualifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-text keyword search across candidate profiles. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Location filters. Results must match at least one of the provided locations. */
  locations?: InputMaybe<Array<OrganisationTalentLocationSearchInput>>;
  /** Filter by qualification IDs. Candidates must hold at least one. */
  qualificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Salary expectation filter. */
  salaryExpectation?: InputMaybe<OrganisationTalentSalaryExpectationSearchInput>;
  /** Filter by skill IDs. Candidates must have experience with at least one. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by skill sub-category IDs. */
  skillSubcategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A location filter for the talent pool search. */
export type OrganisationTalentLocationSearchInput = {
  /** City or suburb. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country name or code. Required. */
  country: Scalars['String']['input'];
  /** Radius in kilometres for distance-based matching. */
  distanceMatching?: InputMaybe<Scalars['Int']['input']>;
  /** State or region. */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Salary expectation range filter for the talent pool search. */
export type OrganisationTalentSalaryExpectationSearchInput = {
  /** Maximum salary expectation. */
  max: Scalars['Int']['input'];
  /** Minimum salary expectation. */
  min: Scalars['Int']['input'];
};

export type Permission = {
  __typename?: 'Permission';
  learningPortal?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalityAssessment = {
  __typename?: 'PersonalityAssessment';
  answers: Array<PersonalityAssessmentAnswer>;
  catchPhrase: Scalars['String']['output'];
  characteristics: Array<Maybe<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  result: Scalars['String']['output'];
};

export type PersonalityAssessmentAnswer = {
  __typename?: 'PersonalityAssessmentAnswer';
  answer: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type PersonalityResultsQueryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalityAssessmentResult = {
  __typename?: 'PersonalityAssessmentResult';
  completedDate?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personalityType?: Maybe<Scalars['String']['output']>;
};

export type WorkArea = {
  __typename?: 'WorkArea';
  fieldId: Scalars['ID']['output'];
  fieldName?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SharePage = {
  __typename?: 'SharePage';
  dateShared?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  shareContent?: Maybe<Scalars['String']['output']>;
  sharer?: Maybe<Scalars['String']['output']>;
  sharerEmail?: Maybe<Scalars['String']['output']>;
  sk?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SsoConfig = {
  __typename?: 'SSOConfig';
  acsUrl?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  logoutUrl?: Maybe<Scalars['String']['output']>;
};

export type SsoConnection = {
  __typename?: 'SSOConnection';
  acsUrl?: Maybe<Scalars['String']['output']>;
  attributeMapping?: Maybe<Scalars['JSON']['output']>;
  autoSignup?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customParams?: Maybe<Scalars['JSON']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  encryptedResponses?: Maybe<Scalars['Boolean']['output']>;
  encryptionCertificate?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idpIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isComponoAdmin?: Maybe<Scalars['Boolean']['output']>;
  logoutUrl?: Maybe<Scalars['String']['output']>;
  metadataFile?: Maybe<Scalars['String']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  replaceLoginPage?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

/** Standalone CV that can be used independently of a candidate profile. */
export type StandaloneCv = {
  __typename?: 'StandaloneCV';
  /** The MIME type of the CV. */
  contentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All processing tasks with their status. */
  processing?: Maybe<StandaloneCvProcessing>;
};

export type StandaloneCvProcessing = {
  __typename?: 'StandaloneCVProcessing';
  convertToPdf?: Maybe<StandaloneCvProcessingConvertToPdf>;
  extractStructuredData?: Maybe<StandaloneCvProcessingExtractStructuredData>;
  generateSummaries?: Maybe<Array<StandaloneCvProcessingGenerateSummary>>;
};

export type StandaloneCvProcessingConvertToPdf = {
  __typename?: 'StandaloneCVProcessingConvertToPdf';
  /** Short lived URL to download the converted PDF. To generate a new URL run the query again. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The error message if the PDF conversion failed. */
  error?: Maybe<Scalars['String']['output']>;
  status: StandaloneCvProcessingStatus;
};

export enum StandaloneCvProcessingStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type StandaloneCvProcessingExtractStructuredData = {
  __typename?: 'StandaloneCVProcessingExtractStructuredData';
  /** The error message if the structured data extraction failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The extracted structured data from the CV. */
  extractedData?: Maybe<StandaloneCvStructuredData>;
  status: StandaloneCvProcessingStatus;
};

export type StandaloneCvStructuredData = {
  __typename?: 'StandaloneCVStructuredData';
  achievements?: Maybe<Array<StandaloneCvAchievement>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hobbies?: Maybe<Array<StandaloneCvHobby>>;
  jobHistory?: Maybe<Array<StandaloneCvJob>>;
  languages?: Maybe<Array<StandaloneCvLanguage>>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<StandaloneCvLocation>;
  other?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalLinks?: Maybe<Array<StandaloneCvProfessionalLink>>;
  qualifications?: Maybe<Array<StandaloneCvQualification>>;
  references?: Maybe<Array<StandaloneCvReference>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvAchievement = {
  __typename?: 'StandaloneCVAchievement';
  awardedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvHobby = {
  __typename?: 'StandaloneCVHobby';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvJob = {
  __typename?: 'StandaloneCVJob';
  companyName?: Maybe<Scalars['String']['output']>;
  currentJob?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  startDate?: Maybe<Scalars['String']['output']>;
  workAreas?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandaloneCvLanguage = {
  __typename?: 'StandaloneCVLanguage';
  language?: Maybe<Scalars['String']['output']>;
  proficiency?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvLocation = {
  __typename?: 'StandaloneCVLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvProfessionalLink = {
  __typename?: 'StandaloneCVProfessionalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvQualification = {
  __typename?: 'StandaloneCVQualification';
  currentlyCompleting?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  qualificationName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvReference = {
  __typename?: 'StandaloneCVReference';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  socialNetworkProfileLinks?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandaloneCvProcessingGenerateSummary = {
  __typename?: 'StandaloneCVProcessingGenerateSummary';
  /** The error message if the summary generation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The format of the summary. */
  format?: Maybe<StandaloneCvSummaryFormat>;
  /** The ID of the standalone CV summary. */
  id: Scalars['ID']['output'];
  /** The status of the summary generation. */
  status: StandaloneCvProcessingStatus;
  /** The structure of the summary. */
  structure?: Maybe<StandaloneCvSummaryStructure>;
  /** The generated summary from the CV. */
  summary?: Maybe<Scalars['String']['output']>;
};

export enum StandaloneCvSummaryFormat {
  Markdown = 'MARKDOWN',
  PlainText = 'PLAIN_TEXT'
}

export enum StandaloneCvSummaryStructure {
  KeyHighlights = 'KEY_HIGHLIGHTS',
  ShortParagraphs = 'SHORT_PARAGRAPHS',
  SingleParagraph = 'SINGLE_PARAGRAPH'
}

export type SystemTag = {
  __typename?: 'SystemTag';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type TagActivityFilter = {
  candidateId?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<TagCategory>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum TagCategory {
  Activity = 'ACTIVITY',
  Candidate = 'CANDIDATE'
}

export type TagActivity = {
  __typename?: 'TagActivity';
  action: TagActivityAction;
  actionedByUser?: Maybe<TagActivityActionedByUser>;
  history: Array<TagActivityHistory>;
  notes?: Maybe<Scalars['String']['output']>;
  tag: Tag;
  targetApplicant?: Maybe<Applicant>;
};

export enum TagActivityAction {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export type TagActivityActionedByUser = {
  __typename?: 'TagActivityActionedByUser';
  timestamp?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type TagActivityHistory = {
  __typename?: 'TagActivityHistory';
  action: TagActivityAction;
  actionedByUser?: Maybe<TagActivityActionedByUser>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type Tag = OrganisationTag | SystemTag;

export type UploadRequest = {
  __typename?: 'UploadRequest';
  /** The ID of the upload request. */
  id: Scalars['ID']['output'];
  /** The URL to upload the file to. */
  uploadUrl: Scalars['String']['output'];
};

export type UserGroupMemberInput = {
  memberId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignGroupRole?: Maybe<GroupMemberResponse>;
  confirmUserEmailUpdate: Scalars['Boolean']['output'];
  createSSOConnection?: Maybe<SsoConnection>;
  /** Create a new standalone CV */
  createStandaloneCV?: Maybe<StandaloneCv>;
  /** Create a new upload request */
  createUploadRequest?: Maybe<UploadRequest>;
  deleteOrganisationTag?: Maybe<DeleteOrganisationTagMutationResult>;
  expireShareLink?: Maybe<Scalars['String']['output']>;
  getInsights?: Maybe<PersonalityInsights>;
  groupAssignUser?: Maybe<GroupMemberResponse>;
  groupCreate?: Maybe<GroupResponse>;
  groupDelete?: Maybe<GroupResponse>;
  groupEdit?: Maybe<GroupResponse>;
  groupUnassignUser?: Maybe<GroupMemberResponse>;
  messageTemplateCreate?: Maybe<MessageTemplateMutationResult>;
  messageTemplateDelete?: Maybe<MessageTemplateMutationResult>;
  messageTemplateUpdate?: Maybe<MessageTemplateMutationResult>;
  organisationTagActivitySet?: Maybe<OrganisationTagActivityMutationResult>;
  organisationTagCreate?: Maybe<OrganisationTagMutationResult>;
  personalityAssessmentInviteMembers?: Maybe<PersonalityAssessmentInviteMembers>;
  personalityAssessmentSaveAnswers?: Maybe<PersonalityAssessment>;
  removeSSOConnection?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a standalone CV */
  removeStandaloneCV?: Maybe<StandaloneCvRemoval>;
  resendUserEmailUpdateCode: Scalars['Boolean']['output'];
  saveComponoAssistReaction?: Maybe<ComponoAssistReaction>;
  shareCultureReport?: Maybe<SharePage>;
  systemTagActivitySet?: Maybe<TagActivityMutationResult>;
  /** Update the score weights used for match ranking on a listing. Triggers a score recalculation. Requires admin role. */
  updateListingScoreWeights?: Maybe<ListingScoreWeights>;
  updateSSOConnection?: Maybe<SsoConnection>;
  validateSkillQualificationMatches: MatchValidationResult;
};


export type MutationAssignGroupRoleArgs = {
  input?: InputMaybe<GroupUserRoleInput>;
};


export type MutationConfirmUserEmailUpdateArgs = {
  input: ConfirmUserEmailUpdateMutationInput;
};


export type MutationCreateSsoConnectionArgs = {
  input: SsoConnectionInput;
};


export type MutationCreateStandaloneCvArgs = {
  input: StandaloneCvCreateInput;
};


export type MutationCreateUploadRequestArgs = {
  input: CreateUploadRequestInput;
};


export type MutationDeleteOrganisationTagArgs = {
  input?: InputMaybe<DeleteOrganisationTagInput>;
};


export type MutationExpireShareLinkArgs = {
  sk?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetInsightsArgs = {
  input?: InputMaybe<PersonalityInsightsInput>;
};


export type MutationGroupAssignUserArgs = {
  input?: InputMaybe<GroupAssignUserInput>;
};


export type MutationGroupCreateArgs = {
  input?: InputMaybe<GroupCreateInput>;
};


export type MutationGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupEditArgs = {
  input?: InputMaybe<GroupEditInput>;
};


export type MutationGroupUnassignUserArgs = {
  input?: InputMaybe<GroupAssignUserInput>;
};


export type MutationMessageTemplateCreateArgs = {
  input: MessageTemplateCreateInput;
};


export type MutationMessageTemplateDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMessageTemplateUpdateArgs = {
  input?: InputMaybe<MessageTemplateUpdateInput>;
};


export type MutationOrganisationTagActivitySetArgs = {
  input: OrganisationTagActivityInput;
};


export type MutationOrganisationTagCreateArgs = {
  input: OrganisationTagCreateInput;
};


export type MutationPersonalityAssessmentInviteMembersArgs = {
  input: PersonalityAssessmentInviteMembersInput;
};


export type MutationPersonalityAssessmentSaveAnswersArgs = {
  input: PersonalityAssessmentAnswersInput;
};


export type MutationRemoveSsoConnectionArgs = {
  id: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationRemoveStandaloneCvArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendUserEmailUpdateCodeArgs = {
  input: ResendUserEmailUpdateCodeMutationInput;
};


export type MutationSaveComponoAssistReactionArgs = {
  input: SaveComponoAssistReactionInput;
};


export type MutationShareCultureReportArgs = {
  input: SharePageInput;
};


export type MutationSystemTagActivitySetArgs = {
  input: SystemTagActivityInput;
};


export type MutationUpdateListingScoreWeightsArgs = {
  input: UpdateListingScoreWeightsInput;
};


export type MutationUpdateSsoConnectionArgs = {
  input: SsoConnectionInput;
};


export type MutationValidateSkillQualificationMatchesArgs = {
  input: MatchValidationRequestInput;
};

export type GroupUserRoleInput = {
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
  role?: InputMaybe<GroupRole>;
};

export type GroupMemberResponse = {
  __typename?: 'GroupMemberResponse';
  errors?: Maybe<Array<Maybe<GroupMemberMutationError>>>;
  groupMember?: Maybe<GroupMember>;
};

export type GroupMemberMutationError = {
  __typename?: 'GroupMemberMutationError';
  code?: Maybe<GroupMemberMutationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GroupMemberMutationErrorCode {
  DuplicateGroupMember = 'DUPLICATE_GROUP_MEMBER',
  GroupMemberNotFound = 'GROUP_MEMBER_NOT_FOUND'
}

export type ConfirmUserEmailUpdateMutationInput = {
  code: Scalars['String']['input'];
  userPool?: InputMaybe<Scalars['String']['input']>;
};

export type SsoConnectionInput = {
  attributeMapping?: InputMaybe<Scalars['JSON']['input']>;
  autoSignup?: InputMaybe<Scalars['Boolean']['input']>;
  callbackUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customParams?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  encryptedResponses?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idpIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  metadataFile?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  replaceLoginPage?: InputMaybe<Scalars['Boolean']['input']>;
  signingCertificate?: InputMaybe<Scalars['String']['input']>;
  type: SsoConnectionType;
};

export enum SsoConnectionType {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type StandaloneCvCreateInput = {
  /** The MIME type of the file. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Base64 encoded file content. */
  fileContent?: InputMaybe<Scalars['String']['input']>;
  /** The name of the file. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The processing options for the file. */
  processing?: InputMaybe<StandaloneCvProcessingInput>;
};

export type StandaloneCvProcessingInput = {
  /** Whether to convert the CV to PDF format. */
  convertToPdf?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to extract structured data from the CV. */
  extractStructuredData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to generate a summary from the CV. */
  generateSummaries?: InputMaybe<Array<StandaloneCvGenerateSummaryInput>>;
};

export type StandaloneCvGenerateSummaryInput = {
  /** The format of the summary. */
  format?: InputMaybe<StandaloneCvSummaryFormat>;
  /** The structure of the summary. */
  structure?: InputMaybe<StandaloneCvSummaryStructure>;
};

export type CreateUploadRequestInput = {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type DeleteOrganisationTagInput = {
  tagId: Scalars['ID']['input'];
};

export type DeleteOrganisationTagMutationResult = {
  __typename?: 'DeleteOrganisationTagMutationResult';
  errors?: Maybe<Array<Maybe<DeleteOrganisationTagMutationError>>>;
  tag?: Maybe<OrganisationTag>;
};

export type DeleteOrganisationTagMutationError = {
  __typename?: 'DeleteOrganisationTagMutationError';
  message?: Maybe<Scalars['String']['output']>;
};

export type PersonalityInsightsInput = {
  distribution?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalityInsights = {
  __typename?: 'PersonalityInsights';
  distributionType?: Maybe<Scalars['String']['output']>;
  distributionTypeSummary?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  mergedSummaries?: Maybe<Scalars['String']['output']>;
  teamSummary?: Maybe<Scalars['String']['output']>;
};

export type GroupAssignUserInput = {
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
};

export type GroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GroupResponse = {
  __typename?: 'GroupResponse';
  errors?: Maybe<Array<Maybe<GroupMutationError>>>;
  group?: Maybe<Group>;
};

export type GroupMutationError = {
  __typename?: 'GroupMutationError';
  code?: Maybe<GroupMutationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GroupMutationErrorCode {
  DuplicateGroup = 'DUPLICATE_GROUP',
  MaxGroupCharactersReached = 'MAX_GROUP_CHARACTERS_REACHED',
  NotAlphanumericGroup = 'NOT_ALPHANUMERIC_GROUP'
}

export type GroupEditInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MessageTemplateCreateInput = {
  content: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type MessageTemplateMutationResult = {
  __typename?: 'MessageTemplateMutationResult';
  errors: Array<Maybe<MessageTemplateMutationError>>;
  messageTemplate?: Maybe<MessageTemplate>;
};

export type MessageTemplateUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationTagActivityInput = {
  activities: Array<OrganisationTagCoreActivityInput>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationTagCoreActivityInput = {
  action: TagActivityAction;
  tagId: Scalars['ID']['input'];
};

export type OrganisationTagActivityMutationResult = {
  __typename?: 'OrganisationTagActivityMutationResult';
  errors: Array<TagActivityMutationError>;
  tagActivities?: Maybe<Array<Maybe<TagActivity>>>;
};

export type TagActivityMutationError = {
  __typename?: 'TagActivityMutationError';
  code?: Maybe<TagActivityMutationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum TagActivityMutationErrorCode {
  InvalidTag = 'INVALID_TAG',
  MaxTagsAssigned = 'MAX_TAGS_ASSIGNED'
}

export type OrganisationTagCreateInput = {
  category: TagCategory;
  label: Scalars['String']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganisationTagMutationResult = {
  __typename?: 'OrganisationTagMutationResult';
  errors: Array<CreateTagError>;
  tag?: Maybe<Tag>;
};

export type CreateTagError = {
  __typename?: 'CreateTagError';
  code?: Maybe<CreateTagErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateTagErrorCode {
  DuplicateTag = 'DUPLICATE_TAG',
  MaxTagCharactersReached = 'MAX_TAG_CHARACTERS_REACHED',
  MaxTagsReached = 'MAX_TAGS_REACHED',
  NotAlphanumericTag = 'NOT_ALPHANUMERIC_TAG'
}

export type PersonalityAssessmentInviteMembersInput = {
  emailContent: Scalars['String']['input'];
  filters: Array<PersonalityResultsQueryInput>;
  fromName: Scalars['String']['input'];
  fromTitle: Scalars['String']['input'];
};

export type PersonalityAssessmentInviteMembers = {
  __typename?: 'PersonalityAssessmentInviteMembers';
  error?: Maybe<Scalars['String']['output']>;
};

export type PersonalityAssessmentAnswersInput = {
  answers: Array<PersonalityAssessmentAnswerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PersonalityAssessmentAnswerInput = {
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type StandaloneCvRemoval = {
  __typename?: 'StandaloneCVRemoval';
  /** The error message if the removal failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the standalone CV. */
  id: Scalars['ID']['output'];
  /** Whether the removal was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendUserEmailUpdateCodeMutationInput = {
  userPool?: InputMaybe<Scalars['String']['input']>;
};

export type SaveComponoAssistReactionInput = {
  feedback: FeedbackType;
  keys: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type SharePageInput = {
  campaignSk: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
  refCampaignSk?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SystemTagActivityInput = {
  action: TagActivityAction;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  tagId: SystemTagId;
};

export enum SystemTagId {
  Favourite = 'FAVOURITE'
}

export type TagActivityMutationResult = {
  __typename?: 'TagActivityMutationResult';
  errors: Array<UserError>;
  tagActivity?: Maybe<TagActivity>;
};

export type UserError = {
  __typename?: 'UserError';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/** Input for updating the score weights on a listing. */
export type UpdateListingScoreWeightsInput = {
  /** The ID of the listing to update the score weights for. */
  listingId: Scalars['ID']['input'];
  /** The new score weights to apply. */
  scoreWeights: ScoreWeightInput;
};

/** Score weight configuration for a listing's match scoring. */
export type ScoreWeightInput = {
  /** Weight (0–100) assigned to assessment scores. */
  assessments?: InputMaybe<Scalars['Int']['input']>;
  /** Weight (0–100) assigned to qualification scores. */
  qualifications?: InputMaybe<Scalars['Int']['input']>;
  /** Weight (0–100) assigned to skill scores. */
  skills?: InputMaybe<Scalars['Int']['input']>;
};

/** The current score weighting configuration for a listing. */
export type ListingScoreWeights = {
  __typename?: 'ListingScoreWeights';
  /** Weight (0–100) applied to assessment scores. */
  assessments?: Maybe<Scalars['Int']['output']>;
  /** Weight (0–100) applied to qualification scores. */
  qualifications?: Maybe<Scalars['Int']['output']>;
  /** Weight (0–100) applied to skill scores. */
  skills?: Maybe<Scalars['Int']['output']>;
};

export type MatchValidationRequestInput = {
  qualifications: Array<QualificationMatchInput>;
  skills: Array<SkillMatchInput>;
};

export type QualificationMatchInput = {
  parsedQualification: QualificationInput;
  possibleMatches: Array<DatabaseMatchInput>;
};

export type QualificationInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DatabaseMatchInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  similarity: Scalars['Float']['input'];
};

export type SkillMatchInput = {
  parsedSkill: SkillInput;
  possibleMatches: Array<DatabaseMatchInput>;
};

export type SkillInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type MatchValidationResult = {
  __typename?: 'MatchValidationResult';
  qualificationMatches: Array<QualificationMatchResult>;
  skillMatches: Array<SkillMatchResult>;
};

export type QualificationMatchResult = {
  __typename?: 'QualificationMatchResult';
  bestMatch?: Maybe<DatabaseMatch>;
  confidence: Scalars['Float']['output'];
  parsedQualification: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

export type DatabaseMatch = {
  __typename?: 'DatabaseMatch';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  similarity: Scalars['Float']['output'];
};

export type SkillMatchResult = {
  __typename?: 'SkillMatchResult';
  bestMatch?: Maybe<DatabaseMatch>;
  confidence: Scalars['Float']['output'];
  parsedSkill: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

/** A protected candidate profile stub used for CV summary federation chain. */
export type ApplicantProtectedProfile = {
  __typename?: 'ApplicantProtectedProfile';
  /** The candidate ID this protected profile belongs to. */
  candidateId: Scalars['ID']['output'];
};

/** A job listing. Owned by the listings service; referenced here as a stub. */
export type Listing = {
  __typename?: 'Listing';
  /** Unique identifier for this listing. */
  id: Scalars['ID']['output'];
};

/** Pagination metadata returned alongside a paginated list result. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The current page number, 1-indexed. */
  page: Scalars['Int']['output'];
  /** The number of items per page. */
  pageSize: Scalars['Int']['output'];
  /** The total number of items matching the query. */
  totalItems: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Pagination input for list queries. */
export type Pagination = {
  /** The page number to fetch, 1-indexed. Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items per page. Defaults to service-defined max. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetApplicantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetApplicantQuery = { __typename?: 'Query', applicant?: { __typename?: 'Applicant', id: string, protectedProfile?: { __typename?: 'ListingApplicantProtectedProfile', candidateId: string, summaryId?: string | null, summary?: string | null } | null } | null };

export type OrganisationTalent_ListItemFragment = { __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, rankingScore?: number | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, userConfirmed?: boolean | null, isPrePopulated?: boolean | null } | null };

export type GetOrganisationTalentsQueryVariables = Exact<{
  input?: InputMaybe<OrganisationTalentSearchInput>;
}>;


export type GetOrganisationTalentsQuery = { __typename?: 'Query', organisationTalents?: Array<{ __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, rankingScore?: number | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, userConfirmed?: boolean | null, isPrePopulated?: boolean | null } | null }> | null };

export type OrganisationTalent_DetailFragment = { __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, employmentOptions: Array<string>, workPersonalityType?: string | null, lastSigninAt?: string | null, willRelocateTo?: Array<{ __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null }> | null, professionalLinks?: Array<{ __typename?: 'OrganisationTalentProfessionalLink', label: string, url: string }> | null, education?: Array<{ __typename?: 'OrganisationTalentEducation', institutionId?: string | null, institutionName?: string | null, startDate?: string | null, endDate?: string | null, completed?: boolean | null, qualification?: { __typename?: 'Qualification', id: string, name: string, typeName: string } | null }> | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null } | null, contact?: { __typename?: 'OrganisationTalentContact', phone1?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null, skills: Array<{ __typename?: 'Skill', id: string, name: string }> }> | null, documents?: Array<{ __typename?: 'OrganisationTalentDocument', id: string, fileName: string, type: OrganisationTalentDocumentType, availableFormats?: Array<{ __typename?: 'OrganisationTalentDocumentFormat', isOriginal?: boolean | null, downloadUrl?: string | null, mimeType?: string | null }> | null }> | null, applicationHistory?: Array<{ __typename?: 'OrganisationTalentApplication', id: string, listingId: string, applicantId: string, canView?: boolean | null, jobTitle: string, appliedDate?: any | null, stageName?: string | null, team?: { __typename?: 'Team', id: string, name: string, organisationId: string } | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, isPrePopulated?: boolean | null, userConfirmed?: boolean | null } | null };

export type GetOrganisationTalentDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganisationTalentDetailsQuery = { __typename?: 'Query', organisationTalent?: { __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, employmentOptions: Array<string>, workPersonalityType?: string | null, lastSigninAt?: string | null, willRelocateTo?: Array<{ __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null }> | null, professionalLinks?: Array<{ __typename?: 'OrganisationTalentProfessionalLink', label: string, url: string }> | null, education?: Array<{ __typename?: 'OrganisationTalentEducation', institutionId?: string | null, institutionName?: string | null, startDate?: string | null, endDate?: string | null, completed?: boolean | null, qualification?: { __typename?: 'Qualification', id: string, name: string, typeName: string } | null }> | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null } | null, contact?: { __typename?: 'OrganisationTalentContact', phone1?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null, skills: Array<{ __typename?: 'Skill', id: string, name: string }> }> | null, documents?: Array<{ __typename?: 'OrganisationTalentDocument', id: string, fileName: string, type: OrganisationTalentDocumentType, availableFormats?: Array<{ __typename?: 'OrganisationTalentDocumentFormat', isOriginal?: boolean | null, downloadUrl?: string | null, mimeType?: string | null }> | null }> | null, applicationHistory?: Array<{ __typename?: 'OrganisationTalentApplication', id: string, listingId: string, applicantId: string, canView?: boolean | null, jobTitle: string, appliedDate?: any | null, stageName?: string | null, team?: { __typename?: 'Team', id: string, name: string, organisationId: string } | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, isPrePopulated?: boolean | null, userConfirmed?: boolean | null } | null } | null };

export type GetOrganisationTalentDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganisationTalentDocumentsQuery = { __typename?: 'Query', organisationTalent?: { __typename?: 'OrganisationTalent', id: string, documents?: Array<{ __typename?: 'OrganisationTalentDocument', id: string, fileName: string, type: OrganisationTalentDocumentType, availableFormats?: Array<{ __typename?: 'OrganisationTalentDocumentFormat', isOriginal?: boolean | null, downloadUrl?: string | null, mimeType?: string | null }> | null }> | null } | null };

export type CulturePerceptionQueryVariables = Exact<{
  assessmentSk: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<CulturePerceptionFilterInput>> | InputMaybe<CulturePerceptionFilterInput>>;
}>;


export type CulturePerceptionQuery = { __typename?: 'Query', culturePerception?: { __typename?: 'CulturePerceptionResult', completedUsersCount?: number | null, totalUsersCompleted?: number | null, perceptionAverage?: { __typename?: 'AssessmentPerception', financial?: number | null, operational?: number | null, learningGrowth?: number | null, customerQuality?: number | null, jobEngagement?: number | null, jobSatisfaction?: number | null, turnoverIntention?: number | null, workMotivation?: number | null, overallClimate?: number | null } | null, perceptionList?: Array<{ __typename?: 'AssessmentPerception', financial?: number | null, operational?: number | null, learningGrowth?: number | null, customerQuality?: number | null, jobEngagement?: number | null, jobSatisfaction?: number | null, turnoverIntention?: number | null, workMotivation?: number | null, overallClimate?: number | null } | null> | null } | null };

export type GetCultureHotspotsQueryVariables = Exact<{
  campaignSk?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCultureHotspotsQuery = { __typename?: 'Query', cultureHotspots?: Array<{ __typename?: 'CultureHotspot', pk?: string | null, sk?: string | null, campaignId?: string | null, campaignName?: string | null, responseCount?: number | null, aggregation?: string | null, current?: any | null, desired?: any | null, hasParent?: boolean | null, aggregateFilter?: string | null } | null> | null };

export type GetMyCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCoursesQuery = { __typename?: 'Query', myCourses?: Array<{ __typename?: 'Course', id: string, title?: string | null, url?: string | null, imageUrl?: string | null, authorName?: string | null, enrolmentStatus?: string | null, mandatory?: boolean | null, hasEvents?: boolean | null, hasAssessments?: boolean | null, categories?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null }> | null };

export type FetchDevelopPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDevelopPermissionsQuery = { __typename?: 'Query', permissions?: { __typename?: 'Permission', learningPortal?: boolean | null } | null };

export type GetDivisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDivisionsQuery = { __typename?: 'Query', divisions: Array<{ __typename?: 'Division', id: string, organisationId: string, name: string, description?: string | null, parentId?: string | null, isDefault?: boolean | null, createdAt?: any | null, updatedAt?: any | null }> };

export type GetFeedbackThemesQueryVariables = Exact<{
  campaignSk: Scalars['String']['input'];
}>;


export type GetFeedbackThemesQuery = { __typename?: 'Query', feedbackThemes?: Array<{ __typename?: 'FeedbackTheme', id: string, title?: string | null, summary?: string | null, processed: boolean, isNoise: boolean, intents: Array<{ __typename?: 'FeedbackSentimentIntent', id?: string | null, topic?: string | null, summary?: string | null, sentiment?: string | null }>, originalFeedbackSks: Array<{ __typename?: 'OriginalFeedbackReference', sk: string, index: number }> }> | null };

export type GetGroupsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups?: Array<{ __typename?: 'Group', organisationId: string, id: string, name: string, memberCount?: number | null, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null> | null };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', organisationId: string, name: string, memberCount?: number | null, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null };

export type CreateGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', groupCreate?: { __typename?: 'GroupResponse', group?: { __typename?: 'Group', id: string, organisationId: string, name: string, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null, errors?: Array<{ __typename?: 'GroupMutationError', message?: string | null } | null> | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', groupEdit?: { __typename?: 'GroupResponse', group?: { __typename?: 'Group', id: string, organisationId: string, name: string, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null, errors?: Array<{ __typename?: 'GroupMutationError', message?: string | null } | null> | null } | null };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', groupDelete?: { __typename?: 'GroupResponse', group?: { __typename?: 'Group', id: string, organisationId: string, name: string, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null } | null };

export type GroupAssignUserMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type GroupAssignUserMutation = { __typename?: 'Mutation', groupAssignUser?: { __typename?: 'GroupMemberResponse', groupMember?: { __typename?: 'GroupMember', groupId: string, memberId: string, memberType?: MemberType | null, organisationId: string, role?: GroupRole | null, roleDisplayName?: string | null } | null, errors?: Array<{ __typename?: 'GroupMemberMutationError', message?: string | null } | null> | null } | null };

export type AssignUserGroupRoleMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  role?: InputMaybe<GroupRole>;
}>;


export type AssignUserGroupRoleMutation = { __typename?: 'Mutation', assignGroupRole?: { __typename?: 'GroupMemberResponse', groupMember?: { __typename?: 'GroupMember', groupId: string, memberId: string, memberType?: MemberType | null, organisationId: string, role?: GroupRole | null, roleDisplayName?: string | null } | null } | null };

export type GroupUnassignUserMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type GroupUnassignUserMutation = { __typename?: 'Mutation', groupUnassignUser?: { __typename?: 'GroupMemberResponse', groupMember?: { __typename?: 'GroupMember', groupId: string, memberId: string, memberType?: MemberType | null, organisationId: string, role?: GroupRole | null, roleDisplayName?: string | null } | null, errors?: Array<{ __typename?: 'GroupMemberMutationError', message?: string | null } | null> | null } | null };

export type GroupMembersQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type GroupMembersQuery = { __typename?: 'Query', groupMembers?: Array<{ __typename?: 'GroupMember', memberId: string, organisationId: string, groupId: string, memberType?: MemberType | null, role?: GroupRole | null, roleDisplayName?: string | null } | null> | null };

export type UserGroupMembersQueryVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type UserGroupMembersQuery = { __typename?: 'Query', userGroupMembers?: Array<{ __typename?: 'GroupMember', memberId: string, organisationId: string, groupId: string, memberType?: MemberType | null, role?: GroupRole | null, roleDisplayName?: string | null } | null> | null };

export type MyGroupMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGroupMembersQuery = { __typename?: 'Query', myGroupMembers?: Array<{ __typename?: 'GroupMember', memberId: string, organisationId: string, groupId: string, memberType?: MemberType | null, role?: GroupRole | null, roleDisplayName?: string | null } | null> | null };

export type HireReportProcessQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  hiringTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  timezoneOffset: Scalars['Int']['input'];
}>;


export type HireReportProcessQuery = { __typename?: 'Query', hireReportProcess: { __typename?: 'HireReportProcess', id: string } };

export type HireReportResultQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HireReportResultQuery = { __typename?: 'Query', hireReportResult?: { __typename?: 'HireReportResult', id: string, report: { __typename?: 'HireReportStats', aggregates: { __typename?: 'HireReport', jobsOpenAtStartDate: number, jobsOpenAtEndDate: number, jobsOpenedInPeriod: number, jobsClosedInPeriod: number, totalApplications: number, totalHires: number, avgTimeToFillInDays: number, avgTimeToHireInDays: number }, applicationSources: { __typename?: 'HireReportApplicationSources', all: Array<{ __typename?: 'HireReportApplicationSourceCount', name: string, count: number }>, hired: Array<{ __typename?: 'HireReportApplicationSourceCount', name: string, count: number }> } }, export: { __typename?: 'HireReportExport', csvUrl: string, noOfEntries: number } } | null };

export type GetIsProcessingListingMatchesQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type GetIsProcessingListingMatchesQuery = { __typename?: 'Query', isProcessingListingMatches: boolean };

export type UpdateListingScoreWeightsMutationVariables = Exact<{
  input: UpdateListingScoreWeightsInput;
}>;


export type UpdateListingScoreWeightsMutation = { __typename?: 'Mutation', updateListingScoreWeights?: { __typename?: 'ListingScoreWeights', skills?: number | null, assessments?: number | null, qualifications?: number | null } | null };

export type GetMessageTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMessageTemplateQuery = { __typename?: 'Query', messageTemplate?: { __typename?: 'MessageTemplate', organisationId?: string | null, id?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null };

export type GetMessageTemplateGenerateQueryVariables = Exact<{
  prompt: Scalars['String']['input'];
  tone: Scalars['String']['input'];
  previousAnswer?: InputMaybe<Scalars['String']['input']>;
  additionalInstruction?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMessageTemplateGenerateQuery = { __typename?: 'Query', messageTemplateGenerate?: { __typename?: 'MessageTemplateGeneratedResult', messageTemplateGenerated?: { __typename?: 'MessageTemplateGenerated', subject: string, content: string } | null, errors?: Array<{ __typename?: 'MessageTemplateMutationError', message?: string | null } | null> | null } | null };

export type GetMessageTemplatesQueryVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMessageTemplatesQuery = { __typename?: 'Query', messageTemplates?: Array<{ __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null> | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  content: Scalars['String']['input'];
}>;


export type CreateMessageTemplateMutation = { __typename?: 'Mutation', messageTemplateCreate?: { __typename?: 'MessageTemplateMutationResult', messageTemplate?: { __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, subject?: string | null, content?: string | null, description?: string | null, enabled?: boolean | null } | null, errors: Array<{ __typename?: 'MessageTemplateMutationError', message?: string | null } | null> } | null };

export type UpdateMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', messageTemplateUpdate?: { __typename?: 'MessageTemplateMutationResult', messageTemplate?: { __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null, errors: Array<{ __typename?: 'MessageTemplateMutationError', message?: string | null } | null> } | null };

export type DeleteMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMessageTemplateMutation = { __typename?: 'Mutation', messageTemplateDelete?: { __typename?: 'MessageTemplateMutationResult', messageTemplate?: { __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null } | null };

export type PersonalityAssessmentQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalityAssessmentQuery = { __typename?: 'Query', personalityAssessment?: { __typename?: 'PersonalityAssessment', id?: string | null, result: string, characteristics: Array<string | null>, catchPhrase: string, answers: Array<{ __typename?: 'PersonalityAssessmentAnswer', questionId: string, answer: string }> } | null };

export type PersonalityAssessmentSaveAnswersMutationVariables = Exact<{
  input: PersonalityAssessmentAnswersInput;
}>;


export type PersonalityAssessmentSaveAnswersMutation = { __typename?: 'Mutation', personalityAssessmentSaveAnswers?: { __typename?: 'PersonalityAssessment', id?: string | null } | null };

export type PersonalityAssessmentInviteMembersMutationVariables = Exact<{
  input: PersonalityAssessmentInviteMembersInput;
}>;


export type PersonalityAssessmentInviteMembersMutation = { __typename?: 'Mutation', personalityAssessmentInviteMembers?: { __typename?: 'PersonalityAssessmentInviteMembers', error?: string | null } | null };

export type GetPersonalityResultsQueriesQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<PersonalityResultsQueryInput>> | InputMaybe<PersonalityResultsQueryInput>>;
}>;


export type GetPersonalityResultsQueriesQuery = { __typename?: 'Query', personalityResults?: Array<{ __typename?: 'PersonalityAssessmentResult', personalityType?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, completedDate?: string | null, division?: string | null, jobTitle?: string | null } | null> | null };

export type GetInsightsMutationVariables = Exact<{
  input: PersonalityInsightsInput;
}>;


export type GetInsightsMutation = { __typename?: 'Mutation', getInsights?: { __typename?: 'PersonalityInsights', distributionType?: string | null, distributionTypeSummary?: string | null, teamSummary?: string | null, mergedSummaries?: string | null, headline?: string | null } | null };

export type GetComponoAssistReactionQueryVariables = Exact<{
  input: GetComponoAssistReactionInput;
}>;


export type GetComponoAssistReactionQuery = { __typename?: 'Query', getComponoAssistReaction?: { __typename?: 'ComponoAssistReaction', feedback: FeedbackType, data?: any | null } | null };

export type SaveComponoAssistReactionMutationVariables = Exact<{
  input: SaveComponoAssistReactionInput;
}>;


export type SaveComponoAssistReactionMutation = { __typename?: 'Mutation', saveComponoAssistReaction?: { __typename?: 'ComponoAssistReaction', feedback: FeedbackType, data?: any | null } | null };

export type RehydrateSkillsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RehydrateSkillsQuery = { __typename?: 'Query', rehydrateSkills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null };

export type RehydrateQualificationsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RehydrateQualificationsQuery = { __typename?: 'Query', rehydrateQualifications?: Array<{ __typename?: 'Qualification', id: string, name: string }> | null };

export type RehydrateWorkAreasQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RehydrateWorkAreasQuery = { __typename?: 'Query', rehydrateWorkAreas?: Array<{ __typename?: 'WorkArea', id: string, name: string }> | null };

export type ShareCultureReportMutationVariables = Exact<{
  input: SharePageInput;
}>;


export type ShareCultureReportMutation = { __typename?: 'Mutation', shareCultureReport?: { __typename?: 'SharePage', link?: string | null } | null };

export type ExpireShareLinkMutationVariables = Exact<{
  sk: Scalars['String']['input'];
}>;


export type ExpireShareLinkMutation = { __typename?: 'Mutation', expireShareLink?: string | null };

export type SharePageLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type SharePageLinksQuery = { __typename?: 'Query', sharePageLinks?: Array<{ __typename?: 'SharePage', sk?: string | null, dateShared?: string | null, link?: string | null, title?: string | null, expiryDate?: string | null, sharer?: string | null, sharerEmail?: string | null, shareContent?: string | null, type?: string | null } | null> | null };

export type SsoConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoConfigQuery = { __typename?: 'Query', ssoConfig?: { __typename?: 'SSOConfig', acsUrl?: string | null, entityId?: string | null, logoutUrl?: string | null } | null };

export type CreateSsoConnectionMutationVariables = Exact<{
  input: SsoConnectionInput;
}>;


export type CreateSsoConnectionMutation = { __typename?: 'Mutation', createSSOConnection?: { __typename: 'SSOConnection', id: string, organisationId: string, type: string } | null };

export type UpdateSsoConnectionMutationVariables = Exact<{
  input: SsoConnectionInput;
}>;


export type UpdateSsoConnectionMutation = { __typename?: 'Mutation', updateSSOConnection?: { __typename: 'SSOConnection', id: string, organisationId: string, type: string } | null };

export type SsoConnectionsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SsoConnectionsQuery = { __typename?: 'Query', ssoConnections: Array<{ __typename?: 'SSOConnection', id: string, name?: string | null, attributeMapping?: any | null, autoSignup?: boolean | null, clientId?: string | null, enabled?: boolean | null, encryptedResponses?: boolean | null, metadataFile?: string | null, metadataUrl?: string | null, replaceLoginPage?: boolean | null, encryptionCertificate?: string | null, type: string }> };

export type RemoveSsoConnectionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RemoveSsoConnectionMutation = { __typename?: 'Mutation', removeSSOConnection?: boolean | null };

export type GetTagActivitiesWithoutHistoryQueryVariables = Exact<{
  filter: TagActivityFilter;
}>;


export type GetTagActivitiesWithoutHistoryQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', action: TagActivityAction, tag: { __typename: 'OrganisationTag', id: string, label?: string | null } | { __typename: 'SystemTag', id: string }, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, targetApplicant?: { __typename?: 'Applicant', candidateId: string } | null }> };

export type GetOrganisationTagActivitiesQueryVariables = Exact<{
  filter: TagActivityFilter;
}>;


export type GetOrganisationTagActivitiesQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', notes?: string | null, action: TagActivityAction, tag: { __typename: 'OrganisationTag', id: string, label?: string | null } | { __typename: 'SystemTag' }, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, targetApplicant?: { __typename?: 'Applicant', candidateId: string } | null }> };

export type GetTagActivitiesQueryVariables = Exact<{
  filter: TagActivityFilter;
}>;


export type GetTagActivitiesQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', action: TagActivityAction, notes?: string | null, tag: { __typename: 'OrganisationTag', id: string, label?: string | null, assignedCount?: number | null } | { __typename: 'SystemTag', id: string }, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, targetApplicant?: { __typename?: 'Applicant', candidateId: string } | null, history: Array<{ __typename?: 'TagActivityHistory', action: TagActivityAction, notes?: string | null, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null }> }> };

export type OrganisationTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationTagsQuery = { __typename?: 'Query', organisationTags: Array<{ __typename?: 'OrganisationTag', id: string, label?: string | null, tagCategory?: string | null, assignedCount?: number | null }> };

export type SystemTagActivitySetMutationVariables = Exact<{
  input: SystemTagActivityInput;
}>;


export type SystemTagActivitySetMutation = { __typename?: 'Mutation', systemTagActivitySet?: { __typename?: 'TagActivityMutationResult', tagActivity?: { __typename?: 'TagActivity', action: TagActivityAction, tag: { __typename?: 'OrganisationTag' } | { __typename?: 'SystemTag', id: string, label?: string | null }, targetApplicant?: { __typename?: 'Applicant', listingId: string, candidateId: string } | null, actionedByUser?: { __typename?: 'TagActivityActionedByUser', user: { __typename?: 'User', id: string } } | null } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type OrganisationTagCreateMutationVariables = Exact<{
  input: OrganisationTagCreateInput;
}>;


export type OrganisationTagCreateMutation = { __typename?: 'Mutation', organisationTagCreate?: { __typename?: 'OrganisationTagMutationResult', tag?: { __typename: 'OrganisationTag', id: string, label?: string | null } | { __typename: 'SystemTag' } | null, errors: Array<{ __typename?: 'CreateTagError', message?: string | null, code?: CreateTagErrorCode | null }> } | null };

export type OrganisationTagActivitySetMutationVariables = Exact<{
  input: OrganisationTagActivityInput;
}>;


export type OrganisationTagActivitySetMutation = { __typename?: 'Mutation', organisationTagActivitySet?: { __typename?: 'OrganisationTagActivityMutationResult', tagActivities?: Array<{ __typename?: 'TagActivity', notes?: string | null, action: TagActivityAction, tag: { __typename?: 'OrganisationTag', id: string, label?: string | null } | { __typename?: 'SystemTag', id: string, label?: string | null }, targetApplicant?: { __typename?: 'Applicant', listingId: string, candidateId: string } | null, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string } } | null } | null> | null, errors: Array<{ __typename?: 'TagActivityMutationError', message?: string | null }> } | null };

export type DeleteOrganisationTagMutationVariables = Exact<{
  input: DeleteOrganisationTagInput;
}>;


export type DeleteOrganisationTagMutation = { __typename?: 'Mutation', deleteOrganisationTag?: { __typename?: 'DeleteOrganisationTagMutationResult', tag?: { __typename: 'OrganisationTag', id: string, label?: string | null } | null, errors?: Array<{ __typename?: 'DeleteOrganisationTagMutationError', message?: string | null } | null> | null } | null };

export type CreateUploadRequestMutationVariables = Exact<{
  input: CreateUploadRequestInput;
}>;


export type CreateUploadRequestMutation = { __typename?: 'Mutation', createUploadRequest?: { __typename?: 'UploadRequest', id: string, uploadUrl: string } | null };

export const OrganisationTalent_ListItemFragmentDoc = gql`
    fragment OrganisationTalent_ListItem on OrganisationTalent {
  id
  firstName
  lastName
  email
  contactLocation {
    country
    state
    city
  }
  jobs {
    company
    startDate
    endDate
    years
    title
    currentJob
  }
  rankingScore
  prePopulate {
    allowed
    userConfirmed
    isPrePopulated
  }
}
    `;
export const OrganisationTalent_DetailFragmentDoc = gql`
    fragment OrganisationTalent_Detail on OrganisationTalent {
  id
  firstName
  lastName
  email
  employmentOptions
  workPersonalityType
  lastSigninAt
  willRelocateTo {
    country
    state
    city
    requiresVisa
  }
  professionalLinks {
    label
    url
  }
  education {
    institutionId
    institutionName
    startDate
    endDate
    completed
    qualification {
      id
      name
      typeName
    }
  }
  contactLocation {
    country
    state
    city
    requiresVisa
  }
  contact {
    phone1
  }
  jobs {
    company
    startDate
    endDate
    years
    title
    currentJob
    skills {
      id
      name
    }
  }
  documents {
    id
    fileName
    type
    availableFormats {
      isOriginal
      downloadUrl
      mimeType
    }
  }
  applicationHistory {
    id
    listingId
    applicantId
    canView
    jobTitle
    appliedDate
    stageName
    team {
      id
      name
      organisationId
    }
  }
  prePopulate {
    allowed
    isPrePopulated
    userConfirmed
  }
}
    `;
export const GetApplicantDocument = gql`
    query getApplicant($id: ID!) {
  applicant(id: $id) {
    id
    protectedProfile {
      candidateId
      summaryId
      summary
    }
  }
}
    `;

/**
 * __useGetApplicantQuery__
 *
 * To run a query within a React component, call `useGetApplicantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicantQuery(baseOptions: Apollo.QueryHookOptions<GetApplicantQuery, GetApplicantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicantQuery, GetApplicantQueryVariables>(GetApplicantDocument, options);
      }
export function useGetApplicantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicantQuery, GetApplicantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicantQuery, GetApplicantQueryVariables>(GetApplicantDocument, options);
        }
export type GetApplicantQueryHookResult = ReturnType<typeof useGetApplicantQuery>;
export type GetApplicantLazyQueryHookResult = ReturnType<typeof useGetApplicantLazyQuery>;
export type GetApplicantQueryResult = Apollo.QueryResult<GetApplicantQuery, GetApplicantQueryVariables>;
export const GetOrganisationTalentsDocument = gql`
    query GetOrganisationTalents($input: OrganisationTalentSearchInput) {
  organisationTalents(input: $input) {
    ...OrganisationTalent_ListItem
  }
}
    ${OrganisationTalent_ListItemFragmentDoc}`;

/**
 * __useGetOrganisationTalentsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTalentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganisationTalentsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>(GetOrganisationTalentsDocument, options);
      }
export function useGetOrganisationTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>(GetOrganisationTalentsDocument, options);
        }
export type GetOrganisationTalentsQueryHookResult = ReturnType<typeof useGetOrganisationTalentsQuery>;
export type GetOrganisationTalentsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTalentsLazyQuery>;
export type GetOrganisationTalentsQueryResult = Apollo.QueryResult<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>;
export const GetOrganisationTalentDetailsDocument = gql`
    query GetOrganisationTalentDetails($id: ID!) {
  organisationTalent(id: $id) {
    ...OrganisationTalent_Detail
  }
}
    ${OrganisationTalent_DetailFragmentDoc}`;

/**
 * __useGetOrganisationTalentDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTalentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTalentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTalentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationTalentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>(GetOrganisationTalentDetailsDocument, options);
      }
export function useGetOrganisationTalentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>(GetOrganisationTalentDetailsDocument, options);
        }
export type GetOrganisationTalentDetailsQueryHookResult = ReturnType<typeof useGetOrganisationTalentDetailsQuery>;
export type GetOrganisationTalentDetailsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTalentDetailsLazyQuery>;
export type GetOrganisationTalentDetailsQueryResult = Apollo.QueryResult<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>;
export const GetOrganisationTalentDocumentsDocument = gql`
    query GetOrganisationTalentDocuments($id: ID!) {
  organisationTalent(id: $id) {
    id
    documents {
      id
      fileName
      type
      availableFormats {
        isOriginal
        downloadUrl
        mimeType
      }
    }
  }
}
    `;

/**
 * __useGetOrganisationTalentDocumentsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTalentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTalentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTalentDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationTalentDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>(GetOrganisationTalentDocumentsDocument, options);
      }
export function useGetOrganisationTalentDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>(GetOrganisationTalentDocumentsDocument, options);
        }
export type GetOrganisationTalentDocumentsQueryHookResult = ReturnType<typeof useGetOrganisationTalentDocumentsQuery>;
export type GetOrganisationTalentDocumentsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTalentDocumentsLazyQuery>;
export type GetOrganisationTalentDocumentsQueryResult = Apollo.QueryResult<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>;
export const CulturePerceptionDocument = gql`
    query culturePerception($assessmentSk: String!, $filters: [CulturePerceptionFilterInput]) {
  culturePerception(assessmentSk: $assessmentSk, filters: $filters) {
    perceptionAverage {
      financial
      operational
      learningGrowth
      customerQuality
      jobEngagement
      jobSatisfaction
      turnoverIntention
      workMotivation
      overallClimate
    }
    perceptionList {
      financial
      operational
      learningGrowth
      customerQuality
      jobEngagement
      jobSatisfaction
      turnoverIntention
      workMotivation
      overallClimate
    }
    completedUsersCount
    totalUsersCompleted
  }
}
    `;

/**
 * __useCulturePerceptionQuery__
 *
 * To run a query within a React component, call `useCulturePerceptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCulturePerceptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCulturePerceptionQuery({
 *   variables: {
 *      assessmentSk: // value for 'assessmentSk'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCulturePerceptionQuery(baseOptions: Apollo.QueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CulturePerceptionQuery, CulturePerceptionQueryVariables>(CulturePerceptionDocument, options);
      }
export function useCulturePerceptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CulturePerceptionQuery, CulturePerceptionQueryVariables>(CulturePerceptionDocument, options);
        }
export type CulturePerceptionQueryHookResult = ReturnType<typeof useCulturePerceptionQuery>;
export type CulturePerceptionLazyQueryHookResult = ReturnType<typeof useCulturePerceptionLazyQuery>;
export type CulturePerceptionQueryResult = Apollo.QueryResult<CulturePerceptionQuery, CulturePerceptionQueryVariables>;
export const GetCultureHotspotsDocument = gql`
    query getCultureHotspots($campaignSk: String, $filter: String) {
  cultureHotspots(campaignSk: $campaignSk, filter: $filter) {
    pk
    sk
    campaignId
    campaignName
    responseCount
    aggregation
    current
    desired
    responseCount
    hasParent
    aggregateFilter
  }
}
    `;

/**
 * __useGetCultureHotspotsQuery__
 *
 * To run a query within a React component, call `useGetCultureHotspotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCultureHotspotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCultureHotspotsQuery({
 *   variables: {
 *      campaignSk: // value for 'campaignSk'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCultureHotspotsQuery(baseOptions?: Apollo.QueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>(GetCultureHotspotsDocument, options);
      }
export function useGetCultureHotspotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>(GetCultureHotspotsDocument, options);
        }
export type GetCultureHotspotsQueryHookResult = ReturnType<typeof useGetCultureHotspotsQuery>;
export type GetCultureHotspotsLazyQueryHookResult = ReturnType<typeof useGetCultureHotspotsLazyQuery>;
export type GetCultureHotspotsQueryResult = Apollo.QueryResult<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>;
export const GetMyCoursesDocument = gql`
    query GetMyCourses {
  myCourses {
    id
    title
    url
    imageUrl
    authorName
    enrolmentStatus
    mandatory
    hasEvents
    hasAssessments
    categories {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMyCoursesQuery__
 *
 * To run a query within a React component, call `useGetMyCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
      }
export function useGetMyCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
        }
export type GetMyCoursesQueryHookResult = ReturnType<typeof useGetMyCoursesQuery>;
export type GetMyCoursesLazyQueryHookResult = ReturnType<typeof useGetMyCoursesLazyQuery>;
export type GetMyCoursesQueryResult = Apollo.QueryResult<GetMyCoursesQuery, GetMyCoursesQueryVariables>;
export const FetchDevelopPermissionsDocument = gql`
    query FetchDevelopPermissions {
  permissions {
    learningPortal
  }
}
    `;

/**
 * __useFetchDevelopPermissionsQuery__
 *
 * To run a query within a React component, call `useFetchDevelopPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDevelopPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDevelopPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDevelopPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>(FetchDevelopPermissionsDocument, options);
      }
export function useFetchDevelopPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>(FetchDevelopPermissionsDocument, options);
        }
export type FetchDevelopPermissionsQueryHookResult = ReturnType<typeof useFetchDevelopPermissionsQuery>;
export type FetchDevelopPermissionsLazyQueryHookResult = ReturnType<typeof useFetchDevelopPermissionsLazyQuery>;
export type FetchDevelopPermissionsQueryResult = Apollo.QueryResult<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>;
export const GetDivisionsDocument = gql`
    query getDivisions {
  divisions {
    id
    organisationId
    name
    description
    parentId
    isDefault
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetDivisionsQuery__
 *
 * To run a query within a React component, call `useGetDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDivisionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
      }
export function useGetDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
        }
export type GetDivisionsQueryHookResult = ReturnType<typeof useGetDivisionsQuery>;
export type GetDivisionsLazyQueryHookResult = ReturnType<typeof useGetDivisionsLazyQuery>;
export type GetDivisionsQueryResult = Apollo.QueryResult<GetDivisionsQuery, GetDivisionsQueryVariables>;
export const GetFeedbackThemesDocument = gql`
    query GetFeedbackThemes($campaignSk: String!) {
  feedbackThemes(campaignSk: $campaignSk) {
    id
    title
    summary
    processed
    isNoise
    intents {
      id
      topic
      summary
      sentiment
    }
    originalFeedbackSks {
      sk
      index
    }
  }
}
    `;

/**
 * __useGetFeedbackThemesQuery__
 *
 * To run a query within a React component, call `useGetFeedbackThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackThemesQuery({
 *   variables: {
 *      campaignSk: // value for 'campaignSk'
 *   },
 * });
 */
export function useGetFeedbackThemesQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>(GetFeedbackThemesDocument, options);
      }
export function useGetFeedbackThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>(GetFeedbackThemesDocument, options);
        }
export type GetFeedbackThemesQueryHookResult = ReturnType<typeof useGetFeedbackThemesQuery>;
export type GetFeedbackThemesLazyQueryHookResult = ReturnType<typeof useGetFeedbackThemesLazyQuery>;
export type GetFeedbackThemesQueryResult = Apollo.QueryResult<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>;
export const GetGroupsDocument = gql`
    query getGroups($search: String) {
  groups(search: $search) {
    organisationId
    id
    name
    memberCount
    members {
      id
    }
    description
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupDocument = gql`
    query getGroup($id: ID!) {
  group(id: $id) {
    organisationId
    name
    memberCount
    members {
      id
    }
    description
  }
}
    `;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($name: String!, $description: String) {
  groupCreate(input: {name: $name, description: $description}) {
    group {
      id
      organisationId
      name
      members {
        id
      }
      description
    }
    errors {
      message
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($id: ID!, $name: String!, $description: String) {
  groupEdit(input: {id: $id, name: $name, description: $description}) {
    group {
      id
      organisationId
      name
      members {
        id
      }
      description
    }
    errors {
      message
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: ID!) {
  groupDelete(id: $id) {
    group {
      id
      organisationId
      name
      members {
        id
      }
      description
    }
  }
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const GroupAssignUserDocument = gql`
    mutation groupAssignUser($groupId: ID!, $memberId: ID!) {
  groupAssignUser(input: {groupId: $groupId, memberId: $memberId}) {
    groupMember {
      groupId
      memberId
      memberType
      organisationId
      role
      roleDisplayName
    }
    errors {
      message
    }
  }
}
    `;
export type GroupAssignUserMutationFn = Apollo.MutationFunction<GroupAssignUserMutation, GroupAssignUserMutationVariables>;

/**
 * __useGroupAssignUserMutation__
 *
 * To run a mutation, you first call `useGroupAssignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupAssignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupAssignUserMutation, { data, loading, error }] = useGroupAssignUserMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGroupAssignUserMutation(baseOptions?: Apollo.MutationHookOptions<GroupAssignUserMutation, GroupAssignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupAssignUserMutation, GroupAssignUserMutationVariables>(GroupAssignUserDocument, options);
      }
export type GroupAssignUserMutationHookResult = ReturnType<typeof useGroupAssignUserMutation>;
export type GroupAssignUserMutationResult = Apollo.MutationResult<GroupAssignUserMutation>;
export type GroupAssignUserMutationOptions = Apollo.BaseMutationOptions<GroupAssignUserMutation, GroupAssignUserMutationVariables>;
export const AssignUserGroupRoleDocument = gql`
    mutation assignUserGroupRole($groupId: ID!, $memberId: ID!, $role: GroupRole) {
  assignGroupRole(input: {groupId: $groupId, memberId: $memberId, role: $role}) {
    groupMember {
      groupId
      memberId
      memberType
      organisationId
      role
      roleDisplayName
    }
  }
}
    `;
export type AssignUserGroupRoleMutationFn = Apollo.MutationFunction<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>;

/**
 * __useAssignUserGroupRoleMutation__
 *
 * To run a mutation, you first call `useAssignUserGroupRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserGroupRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserGroupRoleMutation, { data, loading, error }] = useAssignUserGroupRoleMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      memberId: // value for 'memberId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAssignUserGroupRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>(AssignUserGroupRoleDocument, options);
      }
export type AssignUserGroupRoleMutationHookResult = ReturnType<typeof useAssignUserGroupRoleMutation>;
export type AssignUserGroupRoleMutationResult = Apollo.MutationResult<AssignUserGroupRoleMutation>;
export type AssignUserGroupRoleMutationOptions = Apollo.BaseMutationOptions<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>;
export const GroupUnassignUserDocument = gql`
    mutation groupUnassignUser($groupId: ID!, $memberId: ID!) {
  groupUnassignUser(input: {groupId: $groupId, memberId: $memberId}) {
    groupMember {
      groupId
      memberId
      memberType
      organisationId
      role
      roleDisplayName
    }
    errors {
      message
    }
  }
}
    `;
export type GroupUnassignUserMutationFn = Apollo.MutationFunction<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>;

/**
 * __useGroupUnassignUserMutation__
 *
 * To run a mutation, you first call `useGroupUnassignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUnassignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUnassignUserMutation, { data, loading, error }] = useGroupUnassignUserMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGroupUnassignUserMutation(baseOptions?: Apollo.MutationHookOptions<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>(GroupUnassignUserDocument, options);
      }
export type GroupUnassignUserMutationHookResult = ReturnType<typeof useGroupUnassignUserMutation>;
export type GroupUnassignUserMutationResult = Apollo.MutationResult<GroupUnassignUserMutation>;
export type GroupUnassignUserMutationOptions = Apollo.BaseMutationOptions<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>;
export const GroupMembersDocument = gql`
    query groupMembers($groupId: ID!) {
  groupMembers(input: {groupId: $groupId}) {
    memberId
    organisationId
    groupId
    memberType
    role
    roleDisplayName
  }
}
    `;

/**
 * __useGroupMembersQuery__
 *
 * To run a query within a React component, call `useGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
      }
export function useGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
export type GroupMembersQueryHookResult = ReturnType<typeof useGroupMembersQuery>;
export type GroupMembersLazyQueryHookResult = ReturnType<typeof useGroupMembersLazyQuery>;
export type GroupMembersQueryResult = Apollo.QueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export const UserGroupMembersDocument = gql`
    query userGroupMembers($memberId: ID!) {
  userGroupMembers(input: {memberId: $memberId}) {
    memberId
    organisationId
    groupId
    memberType
    role
    roleDisplayName
  }
}
    `;

/**
 * __useUserGroupMembersQuery__
 *
 * To run a query within a React component, call `useUserGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupMembersQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useUserGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupMembersQuery, UserGroupMembersQueryVariables>(UserGroupMembersDocument, options);
      }
export function useUserGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupMembersQuery, UserGroupMembersQueryVariables>(UserGroupMembersDocument, options);
        }
export type UserGroupMembersQueryHookResult = ReturnType<typeof useUserGroupMembersQuery>;
export type UserGroupMembersLazyQueryHookResult = ReturnType<typeof useUserGroupMembersLazyQuery>;
export type UserGroupMembersQueryResult = Apollo.QueryResult<UserGroupMembersQuery, UserGroupMembersQueryVariables>;
export const MyGroupMembersDocument = gql`
    query myGroupMembers {
  myGroupMembers {
    memberId
    organisationId
    groupId
    memberType
    role
    roleDisplayName
  }
}
    `;

/**
 * __useMyGroupMembersQuery__
 *
 * To run a query within a React component, call `useMyGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupMembersQuery(baseOptions?: Apollo.QueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
      }
export function useMyGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
        }
export type MyGroupMembersQueryHookResult = ReturnType<typeof useMyGroupMembersQuery>;
export type MyGroupMembersLazyQueryHookResult = ReturnType<typeof useMyGroupMembersLazyQuery>;
export type MyGroupMembersQueryResult = Apollo.QueryResult<MyGroupMembersQuery, MyGroupMembersQueryVariables>;
export const HireReportProcessDocument = gql`
    query hireReportProcess($startDate: String!, $endDate: String!, $hiringTeamIds: [String], $timezoneOffset: Int!) {
  hireReportProcess(params: {startDate: $startDate, endDate: $endDate, hiringTeamIds: $hiringTeamIds, timezoneOffset: $timezoneOffset}) {
    id
  }
}
    `;

/**
 * __useHireReportProcessQuery__
 *
 * To run a query within a React component, call `useHireReportProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useHireReportProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHireReportProcessQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      hiringTeamIds: // value for 'hiringTeamIds'
 *      timezoneOffset: // value for 'timezoneOffset'
 *   },
 * });
 */
export function useHireReportProcessQuery(baseOptions: Apollo.QueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HireReportProcessQuery, HireReportProcessQueryVariables>(HireReportProcessDocument, options);
      }
export function useHireReportProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HireReportProcessQuery, HireReportProcessQueryVariables>(HireReportProcessDocument, options);
        }
export type HireReportProcessQueryHookResult = ReturnType<typeof useHireReportProcessQuery>;
export type HireReportProcessLazyQueryHookResult = ReturnType<typeof useHireReportProcessLazyQuery>;
export type HireReportProcessQueryResult = Apollo.QueryResult<HireReportProcessQuery, HireReportProcessQueryVariables>;
export const HireReportResultDocument = gql`
    query hireReportResult($id: ID!) {
  hireReportResult(id: $id) {
    id
    report {
      aggregates {
        jobsOpenAtStartDate
        jobsOpenAtEndDate
        jobsOpenedInPeriod
        jobsClosedInPeriod
        totalApplications
        totalHires
        avgTimeToFillInDays
        avgTimeToHireInDays
      }
      applicationSources {
        all {
          name
          count
        }
        hired {
          name
          count
        }
      }
    }
    export {
      csvUrl
      noOfEntries
    }
  }
}
    `;

/**
 * __useHireReportResultQuery__
 *
 * To run a query within a React component, call `useHireReportResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useHireReportResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHireReportResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHireReportResultQuery(baseOptions: Apollo.QueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HireReportResultQuery, HireReportResultQueryVariables>(HireReportResultDocument, options);
      }
export function useHireReportResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HireReportResultQuery, HireReportResultQueryVariables>(HireReportResultDocument, options);
        }
export type HireReportResultQueryHookResult = ReturnType<typeof useHireReportResultQuery>;
export type HireReportResultLazyQueryHookResult = ReturnType<typeof useHireReportResultLazyQuery>;
export type HireReportResultQueryResult = Apollo.QueryResult<HireReportResultQuery, HireReportResultQueryVariables>;
export const GetIsProcessingListingMatchesDocument = gql`
    query GetIsProcessingListingMatches($listingId: ID!) {
  isProcessingListingMatches(listingId: $listingId)
}
    `;

/**
 * __useGetIsProcessingListingMatchesQuery__
 *
 * To run a query within a React component, call `useGetIsProcessingListingMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsProcessingListingMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsProcessingListingMatchesQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetIsProcessingListingMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetIsProcessingListingMatchesQuery, GetIsProcessingListingMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsProcessingListingMatchesQuery, GetIsProcessingListingMatchesQueryVariables>(GetIsProcessingListingMatchesDocument, options);
      }
export function useGetIsProcessingListingMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsProcessingListingMatchesQuery, GetIsProcessingListingMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsProcessingListingMatchesQuery, GetIsProcessingListingMatchesQueryVariables>(GetIsProcessingListingMatchesDocument, options);
        }
export type GetIsProcessingListingMatchesQueryHookResult = ReturnType<typeof useGetIsProcessingListingMatchesQuery>;
export type GetIsProcessingListingMatchesLazyQueryHookResult = ReturnType<typeof useGetIsProcessingListingMatchesLazyQuery>;
export type GetIsProcessingListingMatchesQueryResult = Apollo.QueryResult<GetIsProcessingListingMatchesQuery, GetIsProcessingListingMatchesQueryVariables>;
export const UpdateListingScoreWeightsDocument = gql`
    mutation UpdateListingScoreWeights($input: UpdateListingScoreWeightsInput!) {
  updateListingScoreWeights(input: $input) {
    skills
    assessments
    qualifications
  }
}
    `;
export type UpdateListingScoreWeightsMutationFn = Apollo.MutationFunction<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>;

/**
 * __useUpdateListingScoreWeightsMutation__
 *
 * To run a mutation, you first call `useUpdateListingScoreWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingScoreWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingScoreWeightsMutation, { data, loading, error }] = useUpdateListingScoreWeightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingScoreWeightsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>(UpdateListingScoreWeightsDocument, options);
      }
export type UpdateListingScoreWeightsMutationHookResult = ReturnType<typeof useUpdateListingScoreWeightsMutation>;
export type UpdateListingScoreWeightsMutationResult = Apollo.MutationResult<UpdateListingScoreWeightsMutation>;
export type UpdateListingScoreWeightsMutationOptions = Apollo.BaseMutationOptions<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>;
export const GetMessageTemplateDocument = gql`
    query getMessageTemplate($id: ID!) {
  messageTemplate(id: $id) {
    organisationId
    id
    name
    description
    subject
    content
    enabled
  }
}
    `;

/**
 * __useGetMessageTemplateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
      }
export function useGetMessageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
export type GetMessageTemplateQueryHookResult = ReturnType<typeof useGetMessageTemplateQuery>;
export type GetMessageTemplateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateLazyQuery>;
export type GetMessageTemplateQueryResult = Apollo.QueryResult<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>;
export const GetMessageTemplateGenerateDocument = gql`
    query getMessageTemplateGenerate($prompt: String!, $tone: String!, $previousAnswer: String, $additionalInstruction: String) {
  messageTemplateGenerate(prompt: $prompt, tone: $tone, previousAnswer: $previousAnswer, additionalInstruction: $additionalInstruction) {
    messageTemplateGenerated {
      subject
      content
    }
    errors {
      message
    }
  }
}
    `;

/**
 * __useGetMessageTemplateGenerateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateGenerateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateGenerateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateGenerateQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      tone: // value for 'tone'
 *      previousAnswer: // value for 'previousAnswer'
 *      additionalInstruction: // value for 'additionalInstruction'
 *   },
 * });
 */
export function useGetMessageTemplateGenerateQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>(GetMessageTemplateGenerateDocument, options);
      }
export function useGetMessageTemplateGenerateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>(GetMessageTemplateGenerateDocument, options);
        }
export type GetMessageTemplateGenerateQueryHookResult = ReturnType<typeof useGetMessageTemplateGenerateQuery>;
export type GetMessageTemplateGenerateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateGenerateLazyQuery>;
export type GetMessageTemplateGenerateQueryResult = Apollo.QueryResult<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>;
export const GetMessageTemplatesDocument = gql`
    query getMessageTemplates($enabled: Boolean) {
  messageTemplates(enabled: $enabled) {
    id
    organisationId
    name
    description
    subject
    content
    enabled
  }
}
    `;

/**
 * __useGetMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplatesQuery({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useGetMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
      }
export function useGetMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
        }
export type GetMessageTemplatesQueryHookResult = ReturnType<typeof useGetMessageTemplatesQuery>;
export type GetMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageTemplatesLazyQuery>;
export type GetMessageTemplatesQueryResult = Apollo.QueryResult<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation createMessageTemplate($name: String!, $description: String, $subject: String!, $content: String!) {
  messageTemplateCreate(input: {name: $name, description: $description, subject: $subject, content: $content, enabled: false}) {
    messageTemplate {
      id
      organisationId
      name
      subject
      content
      description
      enabled
    }
    errors {
      message
    }
  }
}
    `;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation updateMessageTemplate($id: ID!, $name: String, $description: String, $subject: String, $content: String, $enabled: Boolean) {
  messageTemplateUpdate(input: {id: $id, name: $name, description: $description, subject: $subject, content: $content, enabled: $enabled}) {
    messageTemplate {
      id
      organisationId
      name
      description
      subject
      content
      enabled
    }
    errors {
      message
    }
  }
}
    `;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const DeleteMessageTemplateDocument = gql`
    mutation deleteMessageTemplate($id: ID!) {
  messageTemplateDelete(id: $id) {
    messageTemplate {
      id
      organisationId
      name
      description
      subject
      content
      enabled
    }
  }
}
    `;
export type DeleteMessageTemplateMutationFn = Apollo.MutationFunction<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;

/**
 * __useDeleteMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageTemplateMutation, { data, loading, error }] = useDeleteMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>(DeleteMessageTemplateDocument, options);
      }
export type DeleteMessageTemplateMutationHookResult = ReturnType<typeof useDeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationResult = Apollo.MutationResult<DeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;
export const PersonalityAssessmentDocument = gql`
    query PersonalityAssessment {
  personalityAssessment {
    id
    result
    answers {
      questionId
      answer
    }
    characteristics
    catchPhrase
  }
}
    `;

/**
 * __usePersonalityAssessmentQuery__
 *
 * To run a query within a React component, call `usePersonalityAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalityAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalityAssessmentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalityAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>(PersonalityAssessmentDocument, options);
      }
export function usePersonalityAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>(PersonalityAssessmentDocument, options);
        }
export type PersonalityAssessmentQueryHookResult = ReturnType<typeof usePersonalityAssessmentQuery>;
export type PersonalityAssessmentLazyQueryHookResult = ReturnType<typeof usePersonalityAssessmentLazyQuery>;
export type PersonalityAssessmentQueryResult = Apollo.QueryResult<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>;
export const PersonalityAssessmentSaveAnswersDocument = gql`
    mutation PersonalityAssessmentSaveAnswers($input: PersonalityAssessmentAnswersInput!) {
  personalityAssessmentSaveAnswers(input: $input) {
    id
  }
}
    `;
export type PersonalityAssessmentSaveAnswersMutationFn = Apollo.MutationFunction<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>;

/**
 * __usePersonalityAssessmentSaveAnswersMutation__
 *
 * To run a mutation, you first call `usePersonalityAssessmentSaveAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalityAssessmentSaveAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalityAssessmentSaveAnswersMutation, { data, loading, error }] = usePersonalityAssessmentSaveAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonalityAssessmentSaveAnswersMutation(baseOptions?: Apollo.MutationHookOptions<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>(PersonalityAssessmentSaveAnswersDocument, options);
      }
export type PersonalityAssessmentSaveAnswersMutationHookResult = ReturnType<typeof usePersonalityAssessmentSaveAnswersMutation>;
export type PersonalityAssessmentSaveAnswersMutationResult = Apollo.MutationResult<PersonalityAssessmentSaveAnswersMutation>;
export type PersonalityAssessmentSaveAnswersMutationOptions = Apollo.BaseMutationOptions<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>;
export const PersonalityAssessmentInviteMembersDocument = gql`
    mutation PersonalityAssessmentInviteMembers($input: PersonalityAssessmentInviteMembersInput!) {
  personalityAssessmentInviteMembers(input: $input) {
    error
  }
}
    `;
export type PersonalityAssessmentInviteMembersMutationFn = Apollo.MutationFunction<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>;

/**
 * __usePersonalityAssessmentInviteMembersMutation__
 *
 * To run a mutation, you first call `usePersonalityAssessmentInviteMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalityAssessmentInviteMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalityAssessmentInviteMembersMutation, { data, loading, error }] = usePersonalityAssessmentInviteMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonalityAssessmentInviteMembersMutation(baseOptions?: Apollo.MutationHookOptions<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>(PersonalityAssessmentInviteMembersDocument, options);
      }
export type PersonalityAssessmentInviteMembersMutationHookResult = ReturnType<typeof usePersonalityAssessmentInviteMembersMutation>;
export type PersonalityAssessmentInviteMembersMutationResult = Apollo.MutationResult<PersonalityAssessmentInviteMembersMutation>;
export type PersonalityAssessmentInviteMembersMutationOptions = Apollo.BaseMutationOptions<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>;
export const GetPersonalityResultsQueriesDocument = gql`
    query getPersonalityResultsQueries($filters: [PersonalityResultsQueryInput]) {
  personalityResults(filters: $filters) {
    personalityType
    name
    firstName
    lastName
    completedDate
    division
    jobTitle
  }
}
    `;

/**
 * __useGetPersonalityResultsQueriesQuery__
 *
 * To run a query within a React component, call `useGetPersonalityResultsQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalityResultsQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalityResultsQueriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPersonalityResultsQueriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>(GetPersonalityResultsQueriesDocument, options);
      }
export function useGetPersonalityResultsQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>(GetPersonalityResultsQueriesDocument, options);
        }
export type GetPersonalityResultsQueriesQueryHookResult = ReturnType<typeof useGetPersonalityResultsQueriesQuery>;
export type GetPersonalityResultsQueriesLazyQueryHookResult = ReturnType<typeof useGetPersonalityResultsQueriesLazyQuery>;
export type GetPersonalityResultsQueriesQueryResult = Apollo.QueryResult<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>;
export const GetInsightsDocument = gql`
    mutation GetInsights($input: PersonalityInsightsInput!) {
  getInsights(input: $input) {
    distributionType
    distributionTypeSummary
    teamSummary
    mergedSummaries
    headline
  }
}
    `;
export type GetInsightsMutationFn = Apollo.MutationFunction<GetInsightsMutation, GetInsightsMutationVariables>;

/**
 * __useGetInsightsMutation__
 *
 * To run a mutation, you first call `useGetInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getInsightsMutation, { data, loading, error }] = useGetInsightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInsightsMutation(baseOptions?: Apollo.MutationHookOptions<GetInsightsMutation, GetInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetInsightsMutation, GetInsightsMutationVariables>(GetInsightsDocument, options);
      }
export type GetInsightsMutationHookResult = ReturnType<typeof useGetInsightsMutation>;
export type GetInsightsMutationResult = Apollo.MutationResult<GetInsightsMutation>;
export type GetInsightsMutationOptions = Apollo.BaseMutationOptions<GetInsightsMutation, GetInsightsMutationVariables>;
export const GetComponoAssistReactionDocument = gql`
    query GetComponoAssistReaction($input: GetComponoAssistReactionInput!) {
  getComponoAssistReaction(input: $input) {
    feedback
    data
  }
}
    `;

/**
 * __useGetComponoAssistReactionQuery__
 *
 * To run a query within a React component, call `useGetComponoAssistReactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponoAssistReactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponoAssistReactionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComponoAssistReactionQuery(baseOptions: Apollo.QueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>(GetComponoAssistReactionDocument, options);
      }
export function useGetComponoAssistReactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>(GetComponoAssistReactionDocument, options);
        }
export type GetComponoAssistReactionQueryHookResult = ReturnType<typeof useGetComponoAssistReactionQuery>;
export type GetComponoAssistReactionLazyQueryHookResult = ReturnType<typeof useGetComponoAssistReactionLazyQuery>;
export type GetComponoAssistReactionQueryResult = Apollo.QueryResult<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>;
export const SaveComponoAssistReactionDocument = gql`
    mutation SaveComponoAssistReaction($input: SaveComponoAssistReactionInput!) {
  saveComponoAssistReaction(input: $input) {
    feedback
    data
  }
}
    `;
export type SaveComponoAssistReactionMutationFn = Apollo.MutationFunction<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>;

/**
 * __useSaveComponoAssistReactionMutation__
 *
 * To run a mutation, you first call `useSaveComponoAssistReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveComponoAssistReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveComponoAssistReactionMutation, { data, loading, error }] = useSaveComponoAssistReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveComponoAssistReactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>(SaveComponoAssistReactionDocument, options);
      }
export type SaveComponoAssistReactionMutationHookResult = ReturnType<typeof useSaveComponoAssistReactionMutation>;
export type SaveComponoAssistReactionMutationResult = Apollo.MutationResult<SaveComponoAssistReactionMutation>;
export type SaveComponoAssistReactionMutationOptions = Apollo.BaseMutationOptions<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>;
export const RehydrateSkillsDocument = gql`
    query RehydrateSkills($ids: [ID!]!) {
  rehydrateSkills(id: $ids) {
    id
    name
  }
}
    `;

/**
 * __useRehydrateSkillsQuery__
 *
 * To run a query within a React component, call `useRehydrateSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRehydrateSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRehydrateSkillsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRehydrateSkillsQuery(baseOptions: Apollo.QueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>(RehydrateSkillsDocument, options);
      }
export function useRehydrateSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>(RehydrateSkillsDocument, options);
        }
export type RehydrateSkillsQueryHookResult = ReturnType<typeof useRehydrateSkillsQuery>;
export type RehydrateSkillsLazyQueryHookResult = ReturnType<typeof useRehydrateSkillsLazyQuery>;
export type RehydrateSkillsQueryResult = Apollo.QueryResult<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>;
export const RehydrateQualificationsDocument = gql`
    query RehydrateQualifications($ids: [ID!]!) {
  rehydrateQualifications(id: $ids) {
    id
    name
  }
}
    `;

/**
 * __useRehydrateQualificationsQuery__
 *
 * To run a query within a React component, call `useRehydrateQualificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRehydrateQualificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRehydrateQualificationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRehydrateQualificationsQuery(baseOptions: Apollo.QueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>(RehydrateQualificationsDocument, options);
      }
export function useRehydrateQualificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>(RehydrateQualificationsDocument, options);
        }
export type RehydrateQualificationsQueryHookResult = ReturnType<typeof useRehydrateQualificationsQuery>;
export type RehydrateQualificationsLazyQueryHookResult = ReturnType<typeof useRehydrateQualificationsLazyQuery>;
export type RehydrateQualificationsQueryResult = Apollo.QueryResult<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>;
export const RehydrateWorkAreasDocument = gql`
    query RehydrateWorkAreas($ids: [ID!]!) {
  rehydrateWorkAreas(id: $ids) {
    id
    name
  }
}
    `;

/**
 * __useRehydrateWorkAreasQuery__
 *
 * To run a query within a React component, call `useRehydrateWorkAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useRehydrateWorkAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRehydrateWorkAreasQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRehydrateWorkAreasQuery(baseOptions: Apollo.QueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>(RehydrateWorkAreasDocument, options);
      }
export function useRehydrateWorkAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>(RehydrateWorkAreasDocument, options);
        }
export type RehydrateWorkAreasQueryHookResult = ReturnType<typeof useRehydrateWorkAreasQuery>;
export type RehydrateWorkAreasLazyQueryHookResult = ReturnType<typeof useRehydrateWorkAreasLazyQuery>;
export type RehydrateWorkAreasQueryResult = Apollo.QueryResult<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>;
export const ShareCultureReportDocument = gql`
    mutation ShareCultureReport($input: SharePageInput!) {
  shareCultureReport(input: $input) {
    link
  }
}
    `;
export type ShareCultureReportMutationFn = Apollo.MutationFunction<ShareCultureReportMutation, ShareCultureReportMutationVariables>;

/**
 * __useShareCultureReportMutation__
 *
 * To run a mutation, you first call `useShareCultureReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCultureReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCultureReportMutation, { data, loading, error }] = useShareCultureReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareCultureReportMutation(baseOptions?: Apollo.MutationHookOptions<ShareCultureReportMutation, ShareCultureReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareCultureReportMutation, ShareCultureReportMutationVariables>(ShareCultureReportDocument, options);
      }
export type ShareCultureReportMutationHookResult = ReturnType<typeof useShareCultureReportMutation>;
export type ShareCultureReportMutationResult = Apollo.MutationResult<ShareCultureReportMutation>;
export type ShareCultureReportMutationOptions = Apollo.BaseMutationOptions<ShareCultureReportMutation, ShareCultureReportMutationVariables>;
export const ExpireShareLinkDocument = gql`
    mutation ExpireShareLink($sk: String!) {
  expireShareLink(sk: $sk)
}
    `;
export type ExpireShareLinkMutationFn = Apollo.MutationFunction<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>;

/**
 * __useExpireShareLinkMutation__
 *
 * To run a mutation, you first call `useExpireShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireShareLinkMutation, { data, loading, error }] = useExpireShareLinkMutation({
 *   variables: {
 *      sk: // value for 'sk'
 *   },
 * });
 */
export function useExpireShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>(ExpireShareLinkDocument, options);
      }
export type ExpireShareLinkMutationHookResult = ReturnType<typeof useExpireShareLinkMutation>;
export type ExpireShareLinkMutationResult = Apollo.MutationResult<ExpireShareLinkMutation>;
export type ExpireShareLinkMutationOptions = Apollo.BaseMutationOptions<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>;
export const SharePageLinksDocument = gql`
    query SharePageLinks {
  sharePageLinks {
    sk
    dateShared
    link
    title
    expiryDate
    sharer
    sharerEmail
    shareContent
    type
  }
}
    `;

/**
 * __useSharePageLinksQuery__
 *
 * To run a query within a React component, call `useSharePageLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharePageLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharePageLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharePageLinksQuery(baseOptions?: Apollo.QueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharePageLinksQuery, SharePageLinksQueryVariables>(SharePageLinksDocument, options);
      }
export function useSharePageLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharePageLinksQuery, SharePageLinksQueryVariables>(SharePageLinksDocument, options);
        }
export type SharePageLinksQueryHookResult = ReturnType<typeof useSharePageLinksQuery>;
export type SharePageLinksLazyQueryHookResult = ReturnType<typeof useSharePageLinksLazyQuery>;
export type SharePageLinksQueryResult = Apollo.QueryResult<SharePageLinksQuery, SharePageLinksQueryVariables>;
export const SsoConfigDocument = gql`
    query SsoConfig {
  ssoConfig {
    acsUrl
    entityId
    logoutUrl
  }
}
    `;

/**
 * __useSsoConfigQuery__
 *
 * To run a query within a React component, call `useSsoConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoConfigQuery(baseOptions?: Apollo.QueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoConfigQuery, SsoConfigQueryVariables>(SsoConfigDocument, options);
      }
export function useSsoConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoConfigQuery, SsoConfigQueryVariables>(SsoConfigDocument, options);
        }
export type SsoConfigQueryHookResult = ReturnType<typeof useSsoConfigQuery>;
export type SsoConfigLazyQueryHookResult = ReturnType<typeof useSsoConfigLazyQuery>;
export type SsoConfigQueryResult = Apollo.QueryResult<SsoConfigQuery, SsoConfigQueryVariables>;
export const CreateSsoConnectionDocument = gql`
    mutation CreateSSOConnection($input: SSOConnectionInput!) {
  createSSOConnection(input: $input) {
    id
    organisationId
    type
    __typename
  }
}
    `;
export type CreateSsoConnectionMutationFn = Apollo.MutationFunction<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>;

/**
 * __useCreateSsoConnectionMutation__
 *
 * To run a mutation, you first call `useCreateSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSsoConnectionMutation, { data, loading, error }] = useCreateSsoConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>(CreateSsoConnectionDocument, options);
      }
export type CreateSsoConnectionMutationHookResult = ReturnType<typeof useCreateSsoConnectionMutation>;
export type CreateSsoConnectionMutationResult = Apollo.MutationResult<CreateSsoConnectionMutation>;
export type CreateSsoConnectionMutationOptions = Apollo.BaseMutationOptions<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>;
export const UpdateSsoConnectionDocument = gql`
    mutation UpdateSSOConnection($input: SSOConnectionInput!) {
  updateSSOConnection(input: $input) {
    id
    organisationId
    type
    __typename
  }
}
    `;
export type UpdateSsoConnectionMutationFn = Apollo.MutationFunction<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>;

/**
 * __useUpdateSsoConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoConnectionMutation, { data, loading, error }] = useUpdateSsoConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>(UpdateSsoConnectionDocument, options);
      }
export type UpdateSsoConnectionMutationHookResult = ReturnType<typeof useUpdateSsoConnectionMutation>;
export type UpdateSsoConnectionMutationResult = Apollo.MutationResult<UpdateSsoConnectionMutation>;
export type UpdateSsoConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>;
export const SsoConnectionsDocument = gql`
    query SsoConnections($organisationId: ID!) {
  ssoConnections(organisationId: $organisationId) {
    id
    name
    attributeMapping
    autoSignup
    clientId
    enabled
    encryptedResponses
    metadataFile
    metadataUrl
    replaceLoginPage
    encryptionCertificate
    type
  }
}
    `;

/**
 * __useSsoConnectionsQuery__
 *
 * To run a query within a React component, call `useSsoConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoConnectionsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSsoConnectionsQuery(baseOptions: Apollo.QueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoConnectionsQuery, SsoConnectionsQueryVariables>(SsoConnectionsDocument, options);
      }
export function useSsoConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoConnectionsQuery, SsoConnectionsQueryVariables>(SsoConnectionsDocument, options);
        }
export type SsoConnectionsQueryHookResult = ReturnType<typeof useSsoConnectionsQuery>;
export type SsoConnectionsLazyQueryHookResult = ReturnType<typeof useSsoConnectionsLazyQuery>;
export type SsoConnectionsQueryResult = Apollo.QueryResult<SsoConnectionsQuery, SsoConnectionsQueryVariables>;
export const RemoveSsoConnectionDocument = gql`
    mutation RemoveSSOConnection($organisationId: ID!, $id: ID!) {
  removeSSOConnection(organisationId: $organisationId, id: $id)
}
    `;
export type RemoveSsoConnectionMutationFn = Apollo.MutationFunction<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>;

/**
 * __useRemoveSsoConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSsoConnectionMutation, { data, loading, error }] = useRemoveSsoConnectionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>(RemoveSsoConnectionDocument, options);
      }
export type RemoveSsoConnectionMutationHookResult = ReturnType<typeof useRemoveSsoConnectionMutation>;
export type RemoveSsoConnectionMutationResult = Apollo.MutationResult<RemoveSsoConnectionMutation>;
export type RemoveSsoConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>;
export const GetTagActivitiesWithoutHistoryDocument = gql`
    query getTagActivitiesWithoutHistory($filter: TagActivityFilter!) {
  tagActivities(filter: $filter) {
    tag {
      __typename
      ... on SystemTag {
        id
      }
      ... on OrganisationTag {
        id
        label
      }
    }
    actionedByUser {
      user {
        id
        firstName
        lastName
      }
      timestamp
    }
    action
    targetApplicant {
      candidateId
    }
  }
}
    `;

/**
 * __useGetTagActivitiesWithoutHistoryQuery__
 *
 * To run a query within a React component, call `useGetTagActivitiesWithoutHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagActivitiesWithoutHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagActivitiesWithoutHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagActivitiesWithoutHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetTagActivitiesWithoutHistoryQuery, GetTagActivitiesWithoutHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagActivitiesWithoutHistoryQuery, GetTagActivitiesWithoutHistoryQueryVariables>(GetTagActivitiesWithoutHistoryDocument, options);
      }
export function useGetTagActivitiesWithoutHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagActivitiesWithoutHistoryQuery, GetTagActivitiesWithoutHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagActivitiesWithoutHistoryQuery, GetTagActivitiesWithoutHistoryQueryVariables>(GetTagActivitiesWithoutHistoryDocument, options);
        }
export type GetTagActivitiesWithoutHistoryQueryHookResult = ReturnType<typeof useGetTagActivitiesWithoutHistoryQuery>;
export type GetTagActivitiesWithoutHistoryLazyQueryHookResult = ReturnType<typeof useGetTagActivitiesWithoutHistoryLazyQuery>;
export type GetTagActivitiesWithoutHistoryQueryResult = Apollo.QueryResult<GetTagActivitiesWithoutHistoryQuery, GetTagActivitiesWithoutHistoryQueryVariables>;
export const GetOrganisationTagActivitiesDocument = gql`
    query getOrganisationTagActivities($filter: TagActivityFilter!) {
  tagActivities(filter: $filter) {
    tag {
      __typename
      ... on OrganisationTag {
        id
        label
      }
    }
    actionedByUser {
      user {
        id
        firstName
        lastName
      }
      timestamp
    }
    notes
    action
    targetApplicant {
      candidateId
    }
  }
}
    `;

/**
 * __useGetOrganisationTagActivitiesQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTagActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganisationTagActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationTagActivitiesQuery, GetOrganisationTagActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTagActivitiesQuery, GetOrganisationTagActivitiesQueryVariables>(GetOrganisationTagActivitiesDocument, options);
      }
export function useGetOrganisationTagActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTagActivitiesQuery, GetOrganisationTagActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTagActivitiesQuery, GetOrganisationTagActivitiesQueryVariables>(GetOrganisationTagActivitiesDocument, options);
        }
export type GetOrganisationTagActivitiesQueryHookResult = ReturnType<typeof useGetOrganisationTagActivitiesQuery>;
export type GetOrganisationTagActivitiesLazyQueryHookResult = ReturnType<typeof useGetOrganisationTagActivitiesLazyQuery>;
export type GetOrganisationTagActivitiesQueryResult = Apollo.QueryResult<GetOrganisationTagActivitiesQuery, GetOrganisationTagActivitiesQueryVariables>;
export const GetTagActivitiesDocument = gql`
    query getTagActivities($filter: TagActivityFilter!) {
  tagActivities(filter: $filter) {
    tag {
      __typename
      ... on SystemTag {
        id
      }
      ... on OrganisationTag {
        id
        label
        assignedCount
      }
    }
    actionedByUser {
      user {
        id
        firstName
        lastName
      }
      timestamp
    }
    action
    notes
    targetApplicant {
      candidateId
    }
    history {
      action
      actionedByUser {
        user {
          id
          firstName
          lastName
        }
        timestamp
      }
      notes
    }
  }
}
    `;

/**
 * __useGetTagActivitiesQuery__
 *
 * To run a query within a React component, call `useGetTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetTagActivitiesQuery, GetTagActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagActivitiesQuery, GetTagActivitiesQueryVariables>(GetTagActivitiesDocument, options);
      }
export function useGetTagActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagActivitiesQuery, GetTagActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagActivitiesQuery, GetTagActivitiesQueryVariables>(GetTagActivitiesDocument, options);
        }
export type GetTagActivitiesQueryHookResult = ReturnType<typeof useGetTagActivitiesQuery>;
export type GetTagActivitiesLazyQueryHookResult = ReturnType<typeof useGetTagActivitiesLazyQuery>;
export type GetTagActivitiesQueryResult = Apollo.QueryResult<GetTagActivitiesQuery, GetTagActivitiesQueryVariables>;
export const OrganisationTagsDocument = gql`
    query organisationTags {
  organisationTags {
    id
    label
    tagCategory
    assignedCount
  }
}
    `;

/**
 * __useOrganisationTagsQuery__
 *
 * To run a query within a React component, call `useOrganisationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationTagsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationTagsQuery, OrganisationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationTagsQuery, OrganisationTagsQueryVariables>(OrganisationTagsDocument, options);
      }
export function useOrganisationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationTagsQuery, OrganisationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationTagsQuery, OrganisationTagsQueryVariables>(OrganisationTagsDocument, options);
        }
export type OrganisationTagsQueryHookResult = ReturnType<typeof useOrganisationTagsQuery>;
export type OrganisationTagsLazyQueryHookResult = ReturnType<typeof useOrganisationTagsLazyQuery>;
export type OrganisationTagsQueryResult = Apollo.QueryResult<OrganisationTagsQuery, OrganisationTagsQueryVariables>;
export const SystemTagActivitySetDocument = gql`
    mutation systemTagActivitySet($input: SystemTagActivityInput!) {
  systemTagActivitySet(input: $input) {
    tagActivity {
      tag {
        ... on SystemTag {
          id
          label
        }
      }
      targetApplicant {
        listingId
        candidateId
      }
      action
      actionedByUser {
        user {
          id
        }
      }
    }
    errors {
      message
    }
  }
}
    `;
export type SystemTagActivitySetMutationFn = Apollo.MutationFunction<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>;

/**
 * __useSystemTagActivitySetMutation__
 *
 * To run a mutation, you first call `useSystemTagActivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemTagActivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemTagActivitySetMutation, { data, loading, error }] = useSystemTagActivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemTagActivitySetMutation(baseOptions?: Apollo.MutationHookOptions<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>(SystemTagActivitySetDocument, options);
      }
export type SystemTagActivitySetMutationHookResult = ReturnType<typeof useSystemTagActivitySetMutation>;
export type SystemTagActivitySetMutationResult = Apollo.MutationResult<SystemTagActivitySetMutation>;
export type SystemTagActivitySetMutationOptions = Apollo.BaseMutationOptions<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>;
export const OrganisationTagCreateDocument = gql`
    mutation OrganisationTagCreate($input: OrganisationTagCreateInput!) {
  organisationTagCreate(input: $input) {
    tag {
      __typename
      ... on OrganisationTag {
        id
        label
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type OrganisationTagCreateMutationFn = Apollo.MutationFunction<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>;

/**
 * __useOrganisationTagCreateMutation__
 *
 * To run a mutation, you first call `useOrganisationTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTagCreateMutation, { data, loading, error }] = useOrganisationTagCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>(OrganisationTagCreateDocument, options);
      }
export type OrganisationTagCreateMutationHookResult = ReturnType<typeof useOrganisationTagCreateMutation>;
export type OrganisationTagCreateMutationResult = Apollo.MutationResult<OrganisationTagCreateMutation>;
export type OrganisationTagCreateMutationOptions = Apollo.BaseMutationOptions<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>;
export const OrganisationTagActivitySetDocument = gql`
    mutation OrganisationTagActivitySet($input: OrganisationTagActivityInput!) {
  organisationTagActivitySet(input: $input) {
    tagActivities {
      tag {
        ... on SystemTag {
          id
          label
        }
        ... on OrganisationTag {
          id
          label
        }
      }
      targetApplicant {
        listingId
        candidateId
      }
      notes
      action
      actionedByUser {
        user {
          id
        }
        timestamp
      }
    }
    errors {
      message
    }
  }
}
    `;
export type OrganisationTagActivitySetMutationFn = Apollo.MutationFunction<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>;

/**
 * __useOrganisationTagActivitySetMutation__
 *
 * To run a mutation, you first call `useOrganisationTagActivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagActivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTagActivitySetMutation, { data, loading, error }] = useOrganisationTagActivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTagActivitySetMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>(OrganisationTagActivitySetDocument, options);
      }
export type OrganisationTagActivitySetMutationHookResult = ReturnType<typeof useOrganisationTagActivitySetMutation>;
export type OrganisationTagActivitySetMutationResult = Apollo.MutationResult<OrganisationTagActivitySetMutation>;
export type OrganisationTagActivitySetMutationOptions = Apollo.BaseMutationOptions<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>;
export const DeleteOrganisationTagDocument = gql`
    mutation DeleteOrganisationTag($input: DeleteOrganisationTagInput!) {
  deleteOrganisationTag(input: $input) {
    tag {
      __typename
      ... on OrganisationTag {
        id
        label
      }
    }
    errors {
      message
    }
  }
}
    `;
export type DeleteOrganisationTagMutationFn = Apollo.MutationFunction<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>;

/**
 * __useDeleteOrganisationTagMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationTagMutation, { data, loading, error }] = useDeleteOrganisationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>(DeleteOrganisationTagDocument, options);
      }
export type DeleteOrganisationTagMutationHookResult = ReturnType<typeof useDeleteOrganisationTagMutation>;
export type DeleteOrganisationTagMutationResult = Apollo.MutationResult<DeleteOrganisationTagMutation>;
export type DeleteOrganisationTagMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>;
export const CreateUploadRequestDocument = gql`
    mutation CreateUploadRequest($input: CreateUploadRequestInput!) {
  createUploadRequest(input: $input) {
    id
    uploadUrl
  }
}
    `;
export type CreateUploadRequestMutationFn = Apollo.MutationFunction<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>;

/**
 * __useCreateUploadRequestMutation__
 *
 * To run a mutation, you first call `useCreateUploadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadRequestMutation, { data, loading, error }] = useCreateUploadRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>(CreateUploadRequestDocument, options);
      }
export type CreateUploadRequestMutationHookResult = ReturnType<typeof useCreateUploadRequestMutation>;
export type CreateUploadRequestMutationResult = Apollo.MutationResult<CreateUploadRequestMutation>;
export type CreateUploadRequestMutationOptions = Apollo.BaseMutationOptions<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>;